/* eslint-disable @typescript-eslint/no-redeclare, import/first */
/* This file is auto-generated. Do not edit manually. */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountInput = {
  bankAccountId?: string | null | undefined;
  enabled: boolean;
  id: string | number;
  name: string;
  type: AccountType;
};

export const AccountType = {
  Disponibilite: 'DISPONIBILITE',
  Emprunt: 'EMPRUNT',
  EpargneBloquee: 'EPARGNE_BLOQUEE',
  EpargneNonBloque: 'EPARGNE_NON_BLOQUE',
  Immobilisation: 'IMMOBILISATION',
  Provision: 'PROVISION'
} as const;

export type AccountType = typeof AccountType[keyof typeof AccountType];
export const BankStatusEnum = {
  Error: 'ERROR',
  Ok: 'OK',
  RenewNeeded: 'RENEW_NEEDED'
} as const;

export type BankStatusEnum = typeof BankStatusEnum[keyof typeof BankStatusEnum];
export const BuyOrSelltrend = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type BuyOrSelltrend = typeof BuyOrSelltrend[keyof typeof BuyOrSelltrend];
export type ChartDataInput = {
  contexts: Array<StatContextInput>;
};

export type InputRsiStockSignal = {
  buySignal: number;
  /** how many lines of this value do we want to aford */
  maxBuys: number;
  sellSignal: number;
  /** The stop value in percent. 10 means that we need a 10% stop loss */
  stopLoss: number;
};

export type InputSmaStockSignal = {
  buyTrend: BuyOrSelltrend;
  daysInBuyTrend: number;
  daysInSellTrend: number;
  /** how many lines of this value do we want to aford */
  maxBuys: number;
  sellTrend: BuyOrSelltrend;
  /** The stop value in percent. 10 means that we need a 10% stop loss */
  stopLoss: number;
  usedSma: Sma;
};

export const LastEventCause = {
  Signal: 'SIGNAL',
  Stop: 'STOP'
} as const;

export type LastEventCause = typeof LastEventCause[keyof typeof LastEventCause];
export const LastEventType = {
  Buy: 'BUY',
  Sell: 'SELL'
} as const;

export type LastEventType = typeof LastEventType[keyof typeof LastEventType];
/** Types de transaction Powens (TransactionType) */
export const PaymentTypeEnum = {
  Arbitrage: 'arbitrage',
  Bank: 'bank',
  Card: 'card',
  Check: 'check',
  DeferredCard: 'deferred_card',
  Deposit: 'deposit',
  Fee: 'fee',
  LoanRepayment: 'loan_repayment',
  MarketFee: 'market_fee',
  MarketOrder: 'market_order',
  Order: 'order',
  Payback: 'payback',
  Payment: 'payment',
  Payout: 'payout',
  Profit: 'profit',
  Refund: 'refund',
  SummaryCard: 'summary_card',
  Transfer: 'transfer',
  Unknown: 'unknown',
  Withdrawal: 'withdrawal'
} as const;

export type PaymentTypeEnum = typeof PaymentTypeEnum[keyof typeof PaymentTypeEnum];
export const SignalType = {
  Rsi: 'RSI',
  Sma: 'SMA'
} as const;

export type SignalType = typeof SignalType[keyof typeof SignalType];
export const Sma = {
  Sma_20: 'SMA_20',
  Sma_50: 'SMA_50',
  Sma_100: 'SMA_100'
} as const;

export type Sma = typeof Sma[keyof typeof Sma];
export type StatContextEditInput = {
  contextId: string;
  id: string | number;
  postId: string;
};

export type StatContextInput = {
  contextId: string;
  postId: string;
};

export type StatInput = {
  contexts: Array<StatContextEditInput>;
  enabled?: boolean | null | undefined;
  id: string | number;
  name: string;
};

export const TradeEventCause = {
  Signal: 'SIGNAL',
  Stop: 'STOP'
} as const;

export type TradeEventCause = typeof TradeEventCause[keyof typeof TradeEventCause];
export type AddAccountToGroupMutationVariables = Exact<{
  groupId: string;
  name: string;
  type: AccountType;
  enabled: boolean;
}>;


export type AddAccountToGroupMutation = { addAccountToGroup: { id: string } };

export type AddAccountToUserMutationVariables = Exact<{
  userId: string;
  name: string;
  type: AccountType;
  enabled: boolean;
  bankAccountId?: string | null | undefined;
}>;


export type AddAccountToUserMutation = { addAccountToUser: { id: string, accounts: Array<{ id: string, name: string, type: AccountType, enabled: boolean | null }> } };

export type AddContextToGroupMutationVariables = Exact<{
  groupId: string | number;
  name: string;
  contextId: string;
}>;


export type AddContextToGroupMutation = { addContextToGroup: { id: string, contexts: Array<{ id: string, name: string }> } };

export type AddPostToContextMutationVariables = Exact<{
  groupId: string | number;
  name: string;
  contextId: string;
  postId: string | number;
}>;


export type AddPostToContextMutation = { addPostToContext: { id: string, contexts: Array<{ id: string, name: string, posts: Array<{ id: string, name: string }> }> } };

export type AddStatToUserMutationVariables = Exact<{
  stat: StatInput;
}>;


export type AddStatToUserMutation = { addStatToUser: { id: string, stats: Array<{ id: string, name: string, contexts: Array<{ id: string, post: { id: string, name: string }, context: { id: string, name: string } }> }> } };

export type AllStocksQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStocksQuery = { stocks: Array<{ id: string, symbol: string, name: string, currentUser: { follow: boolean } }> };

export type AutomaticOperationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomaticOperationsQuery = { groups: Array<{ id: string, name: string, automaticOperations: Array<{ id: string, credit: number, debit: number, comment: string, nextDate: string, monthDelta: number, user: { id: string, firstname: string } | null, account: { id: string, name: string }, context: { id: string, name: string }, post: { id: string, name: string } }> }> };

export type BalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type BalancesQuery = { groups: Array<{ id: string, name: string, balances: Array<{ id: string, sum: number, user: { id: string, firstname: string } }> }> };

export type BankStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type BankStatusesQuery = { currentUser: { bankStatuses: Array<{ id: string, budgetInsightCode: string | null, status: BankStatusEnum }> } };

export type BanksOfUserQueryVariables = Exact<{ [key: string]: never; }>;


export type BanksOfUserQuery = { banksOfUser: Array<{ id: string, name: string, status: BankStatusEnum, accounts: Array<{ id: string, name: string }> }> };

export type BilanQueryVariables = Exact<{
  date: string;
}>;


export type BilanQuery = { bilan: { totalActive: number, totalPassive: number, total: number, active: Array<{ name: string, total: number, items: Array<{ id: string, amount: number, comment: string, name: string | null, account: { id: string, name: string } | null }> }>, passive: Array<{ name: string, total: number, items: Array<{ id: string, amount: number, comment: string, name: string | null, account: { id: string, name: string } | null }> }> } };

export type ComputeAccountsAmountsMutationVariables = Exact<{ [key: string]: never; }>;


export type ComputeAccountsAmountsMutation = { computeAccountsAmount: { __typename: 'ComputeAccountsAmount', accounts: Array<{ __typename: 'Account', id: string, amount: number }> } };

export type ComputeAllNextAutoTransactionsMutationVariables = Exact<{ [key: string]: never; }>;


export type ComputeAllNextAutoTransactionsMutation = { computeAllNextAutoTransactions: { totalCount: number } };

export type ComputeAverageGainQueryVariables = Exact<{
  stockId: string | number;
  signalType: SignalType;
}>;


export type ComputeAverageGainQuery = { computeAverageGain: { averageGain: number | null, tradesCount: number, gainPerYear: number | null } };

export type ComputeNextAutoTransactionsMutationVariables = Exact<{ [key: string]: never; }>;


export type ComputeNextAutoTransactionsMutation = { computeNextAutoTransactions: { __typename: 'ComputeNextAutoTransactionsOutput', transactions: Array<{ __typename: 'Transaction', id: string }> } };

export type ComputeStatsQueryVariables = Exact<{
  input?: ChartDataInput | null | undefined;
}>;


export type ComputeStatsQuery = { chartData: { contexts: Array<{ year: number, amount: number, comment: string, context: { id: string, name: string }, post: { id: string, name: string } }> } };

export type ConnectBankMutationVariables = Exact<{
  budgetInsideClientID: string;
  budgetInsideClientCode: string;
}>;


export type ConnectBankMutation = { connectBank: { id: string } };

export type CreateAutomaticOperationMutationVariables = Exact<{
  nextDate: string;
  credit: number;
  debit: number;
  monthDelta: number;
  groupId: string;
  userId?: string | null | undefined;
  postId: string;
  contextId: string;
  accountId: string;
  comment: string;
}>;


export type CreateAutomaticOperationMutation = { createAutomaticOperation: { id: string, name: string, automaticOperations: Array<{ id: string, credit: number, debit: number, comment: string, nextDate: string, monthDelta: number, user: { id: string, firstname: string } | null, account: { id: string, name: string }, context: { id: string, name: string }, post: { id: string, name: string } }> } };

export type CreateTransactionMutationVariables = Exact<{
  date: string;
  credit: number;
  debit: number;
  groupId: string;
  userId?: string | null | undefined;
  postId: string;
  contextId: string;
  accountId: string;
  comment: string;
  checked: boolean;
}>;


export type CreateTransactionMutation = { createTransaction: { __typename: 'Transaction', id: string, date: string, comment: string, credit: number, debit: number, checked: boolean, deleted: boolean, paymentType: PaymentTypeEnum | null, initialComment: string | null, autoMatchLabel: string | null, budgetInsideId: string | null, automaticOperationId: string | null, group: { id: string, name: string }, user: { id: string, firstname: string } | null, account: { id: string, name: string }, post: { id: string, name: string }, context: { id: string, name: string } } };

export type CurrentUserAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountsQuery = { currentUser: { id: string, accounts: Array<{ id: string, name: string, enabled: boolean | null, amount: number }> } };

export type CurrentUserAccountsDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountsDetailsQuery = { currentUser: { id: string, firstname: string, accounts: Array<{ id: string, amount: number, name: string, type: AccountType, enabled: boolean | null, hasTransactions: boolean, bankAccount: { id: string } | null }> }, banksOfUser: Array<{ id: string, name: string, status: BankStatusEnum, accounts: Array<{ name: string, id: string }> }>, groups: Array<{ id: string, name: string, accounts: Array<{ id: string, amount: number, name: string, type: AccountType, enabled: boolean | null, hasTransactions: boolean, bankAccount: { id: string } | null }> }> };

export type CurrentUserStocksQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserStocksQuery = { currentUser: { stocks: Array<{ id: string, signals: { id: string, rsi: { id: string, lastComputedAt: string | null, lastEvent: { id: string, date: string, cause: LastEventCause | null, type: LastEventType, buyValue: number, sellValue: number | null } | null } | null, sma: { id: string, lastComputedAt: string | null, lastEvent: { id: string, date: string, cause: LastEventCause | null, type: LastEventType, buyValue: number, sellValue: number | null } | null } | null } | null, stock: { id: string, symbol: string, name: string, historical2: { edges: Array<{ node: { close: number, date: string } }> } | null } }> } };

export type DeleteAutomaticOperationMutationVariables = Exact<{
  id: string;
  groupId: string;
}>;


export type DeleteAutomaticOperationMutation = { deleteAutomaticOperation: { id: string, name: string, automaticOperations: Array<{ id: string, credit: number, debit: number, comment: string, nextDate: string, monthDelta: number, user: { id: string, firstname: string } | null, account: { id: string, name: string }, context: { id: string, name: string }, post: { id: string, name: string } }> } };

export type DeleteGroupAccountMutationVariables = Exact<{
  groupId: string;
  accountId: string;
}>;


export type DeleteGroupAccountMutation = { deleteGroupAccount: { id: string, accounts: Array<{ id: string, name: string, hasTransactions: boolean }> } };

export type DeleteStatMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStatMutation = { deleteStat: { id: string, stats: Array<{ id: string, name: string, contexts: Array<{ id: string, post: { id: string, name: string }, context: { id: string, name: string } }> }> } };

export type DeleteTransactionMutationVariables = Exact<{
  id: string;
}>;


export type DeleteTransactionMutation = { deleteTransaction: { __typename: 'Transaction', id: string, date: string, comment: string, credit: number, debit: number, checked: boolean, deleted: boolean, paymentType: PaymentTypeEnum | null, initialComment: string | null, autoMatchLabel: string | null, budgetInsideId: string | null, automaticOperationId: string | null, group: { id: string, name: string }, user: { id: string, firstname: string } | null, account: { id: string, name: string }, post: { id: string, name: string }, context: { id: string, name: string } } };

export type DeleteUserAccountMutationVariables = Exact<{
  userId: string;
  accountId: string;
}>;


export type DeleteUserAccountMutation = { deleteUserAccount: { id: string, accounts: Array<{ id: string, name: string, hasTransactions: boolean }> } };

export type EditAutomaticOperationMutationVariables = Exact<{
  id: string;
  nextDate: string;
  credit: number;
  debit: number;
  monthDelta: number;
  groupId: string;
  userId?: string | null | undefined;
  postId: string;
  contextId: string;
  accountId: string;
  comment: string;
}>;


export type EditAutomaticOperationMutation = { editAutomaticOperation: { id: string, name: string, automaticOperations: Array<{ id: string, credit: number, debit: number, comment: string, nextDate: string, monthDelta: number, user: { id: string, firstname: string } | null, account: { id: string, name: string }, context: { id: string, name: string }, post: { id: string, name: string } }> } };

export type EditContextMutationVariables = Exact<{
  groupId: string | number;
  contextId: string;
  name: string;
  enabled: boolean;
}>;


export type EditContextMutation = { editContext: { id: string, contexts: Array<{ id: string, name: string, enabled: boolean, posts: Array<{ id: string, name: string, enabled: boolean }> }> } };

export type EditGroupAccountMutationVariables = Exact<{
  groupId: string;
  account: AccountInput;
}>;


export type EditGroupAccountMutation = { editGroupAccount: { id: string } };

export type EditPostMutationVariables = Exact<{
  groupId: string | number;
  contextId: string;
  postId: string | number;
  name: string;
  enabled: boolean;
}>;


export type EditPostMutation = { editPost: { id: string, contexts: Array<{ id: string, name: string, enabled: boolean, posts: Array<{ id: string, name: string, enabled: boolean }> }> } };

export type EditStatMutationVariables = Exact<{
  id: string | number;
  stat: StatInput;
}>;


export type EditStatMutation = { editStat: { id: string, stats: Array<{ id: string, name: string, contexts: Array<{ id: string, post: { id: string, name: string }, context: { id: string, name: string } }> }> } };

export type EditTransactionMutationVariables = Exact<{
  id: string;
  date: string;
  credit: number;
  debit: number;
  groupId: string;
  userId?: string | null | undefined;
  postId: string;
  contextId: string;
  accountId: string;
  comment: string;
  checked: boolean;
}>;


export type EditTransactionMutation = { editTransaction: { __typename: 'Transaction', id: string, date: string, comment: string, credit: number, debit: number, checked: boolean, deleted: boolean, paymentType: PaymentTypeEnum | null, initialComment: string | null, autoMatchLabel: string | null, budgetInsideId: string | null, automaticOperationId: string | null, group: { id: string, name: string }, user: { id: string, firstname: string } | null, account: { id: string, name: string }, post: { id: string, name: string }, context: { id: string, name: string } } };

export type EditUserAccountMutationVariables = Exact<{
  userId: string;
  account: AccountInput;
}>;


export type EditUserAccountMutation = { editUserAccount: { id: string } };

export type FollowStockMutationVariables = Exact<{
  stockId: string | number;
}>;


export type FollowStockMutation = { followStock: { id: string, stocks: Array<{ id: string, stock: { id: string, currentUser: { id: string, follow: boolean } } }> } };

export type GetUserQueryVariables = Exact<{
  id: string | number;
}>;


export type GetUserQuery = { user: { id: string, lastname: string, groups: Array<{ id: string, name: string }>, stats: Array<{ id: string, contexts: Array<{ id: string, post: { id: string, name: string }, context: { id: string, name: string } }> }>, accounts: Array<{ id: string, name: string, type: AccountType, enabled: boolean | null, amount: number }> } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { users: Array<{ id: string, lastname: string }> };

export type GetGroupsDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsDetailsQuery = { groups: Array<{ id: string, name: string, contexts: Array<{ id: string, name: string, enabled: boolean, posts: Array<{ id: string, name: string, enabled: boolean }> }> }> };

export type LinkBankAccountToAccountMutationVariables = Exact<{
  budgetInsideBankAccount: string;
  accountId: string | number;
}>;


export type LinkBankAccountToAccountMutation = { linkBankAccountToAccount: { id: string, name: string, enabled: boolean | null, type: AccountType, amount: number, bankAccount: { id: string } | null } };

export type OptimizeRsiSignalMutationVariables = Exact<{
  stockId: string | number;
}>;


export type OptimizeRsiSignalMutation = { optimizeRsiSignal: { buySignal: number, sellSignal: number, stopLoss: number, gain: number } };

export type PowensWebviewCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type PowensWebviewCodeQuery = { powensWebviewCode: string | null };

export type RefetchRandomStocksMutationVariables = Exact<{ [key: string]: never; }>;


export type RefetchRandomStocksMutation = { refetchRandomStocks: Array<{ id: string }> };

export type RefetchStockDataMutationVariables = Exact<{
  id: string;
}>;


export type RefetchStockDataMutation = { refetchStockData: { id: string, historical2: { edges: Array<{ node: { date: string, close: number } }> } | null } };

export type RefetchStockDatasMutationVariables = Exact<{ [key: string]: never; }>;


export type RefetchStockDatasMutation = { refetchStockDatas: Array<{ id: string, symbol: string }> };

export type ResetAllPowensDataMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetAllPowensDataMutation = { resetAllPowensData: boolean };

export type RestoreTransactionMutationVariables = Exact<{
  id: string;
}>;


export type RestoreTransactionMutation = { restoreTransaction: { __typename: 'Transaction', id: string, date: string, comment: string, credit: number, debit: number, checked: boolean, deleted: boolean, paymentType: PaymentTypeEnum | null, initialComment: string | null, autoMatchLabel: string | null, budgetInsideId: string | null, automaticOperationId: string | null, group: { id: string, name: string }, user: { id: string, firstname: string } | null, account: { id: string, name: string }, post: { id: string, name: string }, context: { id: string, name: string } } };

export type SignalTradeHistoryQueryVariables = Exact<{
  stockId: string | number;
  signalType: SignalType;
}>;


export type SignalTradeHistoryQuery = { signalTradeHistory: Array<{ buyDate: string, buyValue: number, sellDate: string, sellValue: number, gainPercent: number, cause: TradeEventCause }> };

export type UserStatsFragment = { id: string, stats: Array<{ id: string, name: string, contexts: Array<{ id: string, post: { id: string, name: string }, context: { id: string, name: string } }> }> };

export type ChartConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type ChartConfigsQuery = { groups: Array<{ id: string, contexts: Array<{ id: string, name: string, posts: Array<{ id: string, name: string }> }> }>, currentUser: { id: string, stats: Array<{ id: string, name: string, contexts: Array<{ id: string, post: { id: string, name: string }, context: { id: string, name: string } }> }> } };

export type GetStockQueryVariables = Exact<{
  id: string | number;
}>;


export type GetStockQuery = { stock: { id: string, symbol: string } };

export type StockDetailQueryVariables = Exact<{
  id: string | number;
}>;


export type StockDetailQuery = { stock: { id: string, name: string, currentUser: { id: string, signals: { id: string, rsi: { id: string, buySignal: number, sellSignal: number, stopLoss: number, maxBuys: number, lastComputedAt: string | null, lastEvent: { id: string, date: string, cause: LastEventCause | null, type: LastEventType, buyValue: number, sellValue: number | null } | null } | null, sma: { id: string, usedSma: Sma, buyTrend: BuyOrSelltrend, daysInBuyTrend: number, sellTrend: BuyOrSelltrend, daysInSellTrend: number, maxBuys: number, stopLoss: number, lastComputedAt: string | null } | null } | null }, historical2: { edges: Array<{ node: { date: string, adjClose: number, rsi14: number | null, low: number } }> } | null } };

export type GetStocksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStocksQuery = { stocks: Array<{ id: string, symbol: string }> };

export type SyncAccountTransactionsMutationVariables = Exact<{
  accountId: string | number;
  limit?: number | null | undefined;
}>;


export type SyncAccountTransactionsMutation = { syncAccountTransactions: Array<{ id: string, comment: string }> };

export type SyncLastTransactionsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncLastTransactionsMutation = { syncLastTransactions: Array<{ id: string, comment: string }> };

export type SyncLastTransactionsForAllMutationVariables = Exact<{
  limit?: number | null | undefined;
}>;


export type SyncLastTransactionsForAllMutation = { syncLastTransactionsForAll: Array<{ id: string, transactionsCount: number, accountsCount: number }> };

export type TestSignalsMutationVariables = Exact<{ [key: string]: never; }>;


export type TestSignalsMutation = { testSignals: Array<{ id: string }> };

export type TestSignalsForStockMutationVariables = Exact<{
  stockId: string;
}>;


export type TestSignalsForStockMutation = { testSignalsForStock: { id: string, signals: { id: string, rsi: { id: string, lastEvent: { id: string, buyValue: number, sellValue: number | null, type: LastEventType, cause: LastEventCause | null, date: string } | null } | null } | null } };

export type TransactionCommentTypeAheadQueryVariables = Exact<{
  comment: string;
}>;


export type TransactionCommentTypeAheadQuery = { transactionCommentTypeAhead: { items: Array<string> } | null };

export type TransactionFieldsFragment = { id: string, date: string, comment: string, credit: number, debit: number, checked: boolean, deleted: boolean, paymentType: PaymentTypeEnum | null, initialComment: string | null, autoMatchLabel: string | null, budgetInsideId: string | null, automaticOperationId: string | null, group: { id: string, name: string }, user: { id: string, firstname: string } | null, account: { id: string, name: string }, post: { id: string, name: string }, context: { id: string, name: string } };

export type TransactionValuesForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type TransactionValuesForSelectQuery = { groups: Array<{ id: string, name: string, accounts: Array<{ id: string, name: string, enabled: boolean | null }>, users: Array<{ id: string, firstname: string, accounts: Array<{ id: string, name: string, enabled: boolean | null }> }>, contexts: Array<{ id: string, name: string, posts: Array<{ id: string, name: string }> }> }> };

export type TransactionsQueryVariables = Exact<{
  comment?: string | null | undefined;
  accountIds?: Array<string> | string | null | undefined;
  userIds?: Array<string> | string | null | undefined;
  groupIds?: Array<string> | string | null | undefined;
  contextIds?: Array<string> | string | null | undefined;
  postIds?: Array<string> | string | null | undefined;
  perPage?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  paymentType?: PaymentTypeEnum | null | undefined;
  autoMatchLabel?: string | null | undefined;
  amountMin?: number | null | undefined;
  amountMax?: number | null | undefined;
}>;


export type TransactionsQuery = { listTransactions: { items: Array<{ id: string, date: string, comment: string, credit: number, debit: number, checked: boolean, deleted: boolean, paymentType: PaymentTypeEnum | null, initialComment: string | null, autoMatchLabel: string | null, budgetInsideId: string | null, automaticOperationId: string | null, group: { id: string, name: string }, user: { id: string, firstname: string } | null, account: { id: string, name: string }, post: { id: string, name: string }, context: { id: string, name: string } }> }, uncheckedTransactions: { items: Array<{ id: string, date: string, comment: string, credit: number, debit: number, checked: boolean, deleted: boolean, paymentType: PaymentTypeEnum | null, initialComment: string | null, autoMatchLabel: string | null, budgetInsideId: string | null, automaticOperationId: string | null, group: { id: string, name: string }, user: { id: string, firstname: string } | null, account: { id: string, name: string }, post: { id: string, name: string }, context: { id: string, name: string } }> } };

export type UnfollowStockMutationVariables = Exact<{
  stockId: string | number;
}>;


export type UnfollowStockMutation = { unfollowStock: { id: string, stocks: Array<{ id: string, follow: boolean }> } };

export type UnlinkBankAccountMutationVariables = Exact<{
  connectionId: string;
}>;


export type UnlinkBankAccountMutation = { unlinkBankAccount: { id: string } };

export type UpdateRsiSignalMutationVariables = Exact<{
  stockId: string | number;
  input?: InputRsiStockSignal | null | undefined;
}>;


export type UpdateRsiSignalMutation = { updateRsiSignal: { id: string, stocks: Array<{ id: string, signals: { id: string, rsi: { buySignal: number, sellSignal: number, maxBuys: number, stopLoss: number, id: string, lastEvent: { id: string, buyValue: number, sellValue: number | null, type: LastEventType, cause: LastEventCause | null, date: string } | null } | null } | null }> } };

export type UpdateSmaSignalMutationVariables = Exact<{
  stockId: string | number;
  input?: InputSmaStockSignal | null | undefined;
}>;


export type UpdateSmaSignalMutation = { updateSmaSignal: { id: string, stocks: Array<{ id: string, signals: { id: string, sma: { usedSma: Sma, buyTrend: BuyOrSelltrend, daysInBuyTrend: number, sellTrend: BuyOrSelltrend, daysInSellTrend: number, maxBuys: number, stopLoss: number, id: string } | null } | null }> } };

export type UpdateUserAccountMutationVariables = Exact<{
  userId: string;
  account: AccountInput;
}>;


export type UpdateUserAccountMutation = { editUserAccount: { id: string, accounts: Array<{ id: string, name: string, type: AccountType, enabled: boolean | null }> } };

export type TransactionsListValuesForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type TransactionsListValuesForSelectQuery = { users: Array<{ id: string, firstname: string, accounts: Array<{ id: string, name: string, enabled: boolean | null }> }>, groups: Array<{ id: string, name: string, accounts: Array<{ id: string, name: string, enabled: boolean | null }>, users: Array<{ id: string, accounts: Array<{ id: string, name: string, enabled: boolean | null }> }>, contexts: Array<{ id: string, name: string, posts: Array<{ id: string, name: string }> }> }> };

export const UserStatsFragmentDoc = gql`
    fragment userStats on User {
  id
  stats {
    id
    name
    contexts {
      id
      post {
        id
        name
      }
      context {
        id
        name
      }
    }
  }
}
    `;
export const TransactionFieldsFragmentDoc = gql`
    fragment transactionFields on Transaction {
  id
  date
  comment
  credit
  debit
  checked
  deleted
  group {
    id
    name
  }
  user {
    id
    firstname
  }
  account {
    id
    name
  }
  post {
    id
    name
  }
  context {
    id
    name
  }
  paymentType
  initialComment
  autoMatchLabel
  budgetInsideId
  automaticOperationId
}
    `;
export const AddAccountToGroupDocument = gql`
    mutation addAccountToGroup($groupId: String!, $name: String!, $type: AccountType!, $enabled: Boolean!) {
  addAccountToGroup(
    groupId: $groupId
    name: $name
    type: $type
    enabled: $enabled
  ) {
    id
  }
}
    `;
export type AddAccountToGroupMutationFn = Apollo.MutationFunction<AddAccountToGroupMutation, AddAccountToGroupMutationVariables>;

/**
 * __useAddAccountToGroupMutation__
 *
 * To run a mutation, you first call `useAddAccountToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountToGroupMutation, { data, loading, error }] = useAddAccountToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useAddAccountToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountToGroupMutation, AddAccountToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountToGroupMutation, AddAccountToGroupMutationVariables>(AddAccountToGroupDocument, options);
      }
export type AddAccountToGroupMutationHookResult = ReturnType<typeof useAddAccountToGroupMutation>;
export type AddAccountToGroupMutationResult = Apollo.MutationResult<AddAccountToGroupMutation>;
export type AddAccountToGroupMutationOptions = Apollo.BaseMutationOptions<AddAccountToGroupMutation, AddAccountToGroupMutationVariables>;
export const AddAccountToUserDocument = gql`
    mutation addAccountToUser($userId: String!, $name: String!, $type: AccountType!, $enabled: Boolean!, $bankAccountId: String) {
  addAccountToUser(
    userId: $userId
    name: $name
    type: $type
    enabled: $enabled
    bankAccountId: $bankAccountId
  ) {
    id
    accounts {
      id
      name
      type
      enabled
    }
  }
}
    `;
export type AddAccountToUserMutationFn = Apollo.MutationFunction<AddAccountToUserMutation, AddAccountToUserMutationVariables>;

/**
 * __useAddAccountToUserMutation__
 *
 * To run a mutation, you first call `useAddAccountToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountToUserMutation, { data, loading, error }] = useAddAccountToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      enabled: // value for 'enabled'
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useAddAccountToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountToUserMutation, AddAccountToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountToUserMutation, AddAccountToUserMutationVariables>(AddAccountToUserDocument, options);
      }
export type AddAccountToUserMutationHookResult = ReturnType<typeof useAddAccountToUserMutation>;
export type AddAccountToUserMutationResult = Apollo.MutationResult<AddAccountToUserMutation>;
export type AddAccountToUserMutationOptions = Apollo.BaseMutationOptions<AddAccountToUserMutation, AddAccountToUserMutationVariables>;
export const AddContextToGroupDocument = gql`
    mutation addContextToGroup($groupId: ID!, $name: String!, $contextId: String!) {
  addContextToGroup(groupId: $groupId, name: $name, contextId: $contextId) {
    id
    contexts {
      id
      name
    }
  }
}
    `;
export type AddContextToGroupMutationFn = Apollo.MutationFunction<AddContextToGroupMutation, AddContextToGroupMutationVariables>;

/**
 * __useAddContextToGroupMutation__
 *
 * To run a mutation, you first call `useAddContextToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContextToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContextToGroupMutation, { data, loading, error }] = useAddContextToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      name: // value for 'name'
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useAddContextToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddContextToGroupMutation, AddContextToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContextToGroupMutation, AddContextToGroupMutationVariables>(AddContextToGroupDocument, options);
      }
export type AddContextToGroupMutationHookResult = ReturnType<typeof useAddContextToGroupMutation>;
export type AddContextToGroupMutationResult = Apollo.MutationResult<AddContextToGroupMutation>;
export type AddContextToGroupMutationOptions = Apollo.BaseMutationOptions<AddContextToGroupMutation, AddContextToGroupMutationVariables>;
export const AddPostToContextDocument = gql`
    mutation addPostToContext($groupId: ID!, $name: String!, $contextId: String!, $postId: ID!) {
  addPostToContext(
    groupId: $groupId
    name: $name
    contextId: $contextId
    postId: $postId
  ) {
    id
    contexts {
      id
      name
      posts {
        id
        name
      }
    }
  }
}
    `;
export type AddPostToContextMutationFn = Apollo.MutationFunction<AddPostToContextMutation, AddPostToContextMutationVariables>;

/**
 * __useAddPostToContextMutation__
 *
 * To run a mutation, you first call `useAddPostToContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostToContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostToContextMutation, { data, loading, error }] = useAddPostToContextMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      name: // value for 'name'
 *      contextId: // value for 'contextId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useAddPostToContextMutation(baseOptions?: Apollo.MutationHookOptions<AddPostToContextMutation, AddPostToContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostToContextMutation, AddPostToContextMutationVariables>(AddPostToContextDocument, options);
      }
export type AddPostToContextMutationHookResult = ReturnType<typeof useAddPostToContextMutation>;
export type AddPostToContextMutationResult = Apollo.MutationResult<AddPostToContextMutation>;
export type AddPostToContextMutationOptions = Apollo.BaseMutationOptions<AddPostToContextMutation, AddPostToContextMutationVariables>;
export const AddStatToUserDocument = gql`
    mutation addStatToUser($stat: StatInput!) {
  addStatToUser(stat: $stat) {
    ...userStats
  }
}
    ${UserStatsFragmentDoc}`;
export type AddStatToUserMutationFn = Apollo.MutationFunction<AddStatToUserMutation, AddStatToUserMutationVariables>;

/**
 * __useAddStatToUserMutation__
 *
 * To run a mutation, you first call `useAddStatToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStatToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStatToUserMutation, { data, loading, error }] = useAddStatToUserMutation({
 *   variables: {
 *      stat: // value for 'stat'
 *   },
 * });
 */
export function useAddStatToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddStatToUserMutation, AddStatToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStatToUserMutation, AddStatToUserMutationVariables>(AddStatToUserDocument, options);
      }
export type AddStatToUserMutationHookResult = ReturnType<typeof useAddStatToUserMutation>;
export type AddStatToUserMutationResult = Apollo.MutationResult<AddStatToUserMutation>;
export type AddStatToUserMutationOptions = Apollo.BaseMutationOptions<AddStatToUserMutation, AddStatToUserMutationVariables>;
export const AllStocksDocument = gql`
    query allStocks {
  stocks {
    id
    symbol
    name
    currentUser {
      follow
    }
  }
}
    `;

/**
 * __useAllStocksQuery__
 *
 * To run a query within a React component, call `useAllStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllStocksQuery(baseOptions?: Apollo.QueryHookOptions<AllStocksQuery, AllStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStocksQuery, AllStocksQueryVariables>(AllStocksDocument, options);
      }
export function useAllStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStocksQuery, AllStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStocksQuery, AllStocksQueryVariables>(AllStocksDocument, options);
        }
// @ts-ignore
export function useAllStocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllStocksQuery, AllStocksQueryVariables>): Apollo.UseSuspenseQueryResult<AllStocksQuery, AllStocksQueryVariables>;
export function useAllStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStocksQuery, AllStocksQueryVariables>): Apollo.UseSuspenseQueryResult<AllStocksQuery | undefined, AllStocksQueryVariables>;
export function useAllStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStocksQuery, AllStocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStocksQuery, AllStocksQueryVariables>(AllStocksDocument, options);
        }
export type AllStocksQueryHookResult = ReturnType<typeof useAllStocksQuery>;
export type AllStocksLazyQueryHookResult = ReturnType<typeof useAllStocksLazyQuery>;
export type AllStocksSuspenseQueryHookResult = ReturnType<typeof useAllStocksSuspenseQuery>;
export type AllStocksQueryResult = Apollo.QueryResult<AllStocksQuery, AllStocksQueryVariables>;
export const AutomaticOperationsDocument = gql`
    query automaticOperations {
  groups {
    id
    name
    automaticOperations {
      id
      credit
      debit
      comment
      nextDate
      monthDelta
      user {
        id
        firstname
      }
      account {
        id
        name
      }
      context {
        id
        name
      }
      post {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAutomaticOperationsQuery__
 *
 * To run a query within a React component, call `useAutomaticOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomaticOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomaticOperationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutomaticOperationsQuery(baseOptions?: Apollo.QueryHookOptions<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>(AutomaticOperationsDocument, options);
      }
export function useAutomaticOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>(AutomaticOperationsDocument, options);
        }
// @ts-ignore
export function useAutomaticOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>;
export function useAutomaticOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomaticOperationsQuery | undefined, AutomaticOperationsQueryVariables>;
export function useAutomaticOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>(AutomaticOperationsDocument, options);
        }
export type AutomaticOperationsQueryHookResult = ReturnType<typeof useAutomaticOperationsQuery>;
export type AutomaticOperationsLazyQueryHookResult = ReturnType<typeof useAutomaticOperationsLazyQuery>;
export type AutomaticOperationsSuspenseQueryHookResult = ReturnType<typeof useAutomaticOperationsSuspenseQuery>;
export type AutomaticOperationsQueryResult = Apollo.QueryResult<AutomaticOperationsQuery, AutomaticOperationsQueryVariables>;
export const BalancesDocument = gql`
    query balances {
  groups {
    id
    name
    balances {
      id
      user {
        id
        firstname
      }
      sum
    }
  }
}
    `;

/**
 * __useBalancesQuery__
 *
 * To run a query within a React component, call `useBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalancesQuery(baseOptions?: Apollo.QueryHookOptions<BalancesQuery, BalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalancesQuery, BalancesQueryVariables>(BalancesDocument, options);
      }
export function useBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalancesQuery, BalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalancesQuery, BalancesQueryVariables>(BalancesDocument, options);
        }
// @ts-ignore
export function useBalancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BalancesQuery, BalancesQueryVariables>): Apollo.UseSuspenseQueryResult<BalancesQuery, BalancesQueryVariables>;
export function useBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BalancesQuery, BalancesQueryVariables>): Apollo.UseSuspenseQueryResult<BalancesQuery | undefined, BalancesQueryVariables>;
export function useBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BalancesQuery, BalancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BalancesQuery, BalancesQueryVariables>(BalancesDocument, options);
        }
export type BalancesQueryHookResult = ReturnType<typeof useBalancesQuery>;
export type BalancesLazyQueryHookResult = ReturnType<typeof useBalancesLazyQuery>;
export type BalancesSuspenseQueryHookResult = ReturnType<typeof useBalancesSuspenseQuery>;
export type BalancesQueryResult = Apollo.QueryResult<BalancesQuery, BalancesQueryVariables>;
export const BankStatusesDocument = gql`
    query bankStatuses {
  currentUser {
    bankStatuses {
      id
      budgetInsightCode
      status
    }
  }
}
    `;

/**
 * __useBankStatusesQuery__
 *
 * To run a query within a React component, call `useBankStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankStatusesQuery(baseOptions?: Apollo.QueryHookOptions<BankStatusesQuery, BankStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankStatusesQuery, BankStatusesQueryVariables>(BankStatusesDocument, options);
      }
export function useBankStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankStatusesQuery, BankStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankStatusesQuery, BankStatusesQueryVariables>(BankStatusesDocument, options);
        }
// @ts-ignore
export function useBankStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankStatusesQuery, BankStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<BankStatusesQuery, BankStatusesQueryVariables>;
export function useBankStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankStatusesQuery, BankStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<BankStatusesQuery | undefined, BankStatusesQueryVariables>;
export function useBankStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankStatusesQuery, BankStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankStatusesQuery, BankStatusesQueryVariables>(BankStatusesDocument, options);
        }
export type BankStatusesQueryHookResult = ReturnType<typeof useBankStatusesQuery>;
export type BankStatusesLazyQueryHookResult = ReturnType<typeof useBankStatusesLazyQuery>;
export type BankStatusesSuspenseQueryHookResult = ReturnType<typeof useBankStatusesSuspenseQuery>;
export type BankStatusesQueryResult = Apollo.QueryResult<BankStatusesQuery, BankStatusesQueryVariables>;
export const BanksOfUserDocument = gql`
    query banksOfUser {
  banksOfUser {
    id
    name
    status
    accounts {
      id
      name
    }
  }
}
    `;

/**
 * __useBanksOfUserQuery__
 *
 * To run a query within a React component, call `useBanksOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBanksOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBanksOfUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useBanksOfUserQuery(baseOptions?: Apollo.QueryHookOptions<BanksOfUserQuery, BanksOfUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BanksOfUserQuery, BanksOfUserQueryVariables>(BanksOfUserDocument, options);
      }
export function useBanksOfUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BanksOfUserQuery, BanksOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BanksOfUserQuery, BanksOfUserQueryVariables>(BanksOfUserDocument, options);
        }
// @ts-ignore
export function useBanksOfUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BanksOfUserQuery, BanksOfUserQueryVariables>): Apollo.UseSuspenseQueryResult<BanksOfUserQuery, BanksOfUserQueryVariables>;
export function useBanksOfUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BanksOfUserQuery, BanksOfUserQueryVariables>): Apollo.UseSuspenseQueryResult<BanksOfUserQuery | undefined, BanksOfUserQueryVariables>;
export function useBanksOfUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BanksOfUserQuery, BanksOfUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BanksOfUserQuery, BanksOfUserQueryVariables>(BanksOfUserDocument, options);
        }
export type BanksOfUserQueryHookResult = ReturnType<typeof useBanksOfUserQuery>;
export type BanksOfUserLazyQueryHookResult = ReturnType<typeof useBanksOfUserLazyQuery>;
export type BanksOfUserSuspenseQueryHookResult = ReturnType<typeof useBanksOfUserSuspenseQuery>;
export type BanksOfUserQueryResult = Apollo.QueryResult<BanksOfUserQuery, BanksOfUserQueryVariables>;
export const BilanDocument = gql`
    query bilan($date: Date!) {
  bilan(date: $date) {
    totalActive
    totalPassive
    total
    active {
      name
      total
      items {
        id
        amount
        comment
        name
        account {
          id
          name
        }
      }
    }
    passive {
      name
      total
      items {
        id
        amount
        comment
        name
        account {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useBilanQuery__
 *
 * To run a query within a React component, call `useBilanQuery` and pass it any options that fit your needs.
 * When your component renders, `useBilanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBilanQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useBilanQuery(baseOptions: Apollo.QueryHookOptions<BilanQuery, BilanQueryVariables> & ({ variables: BilanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BilanQuery, BilanQueryVariables>(BilanDocument, options);
      }
export function useBilanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BilanQuery, BilanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BilanQuery, BilanQueryVariables>(BilanDocument, options);
        }
// @ts-ignore
export function useBilanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BilanQuery, BilanQueryVariables>): Apollo.UseSuspenseQueryResult<BilanQuery, BilanQueryVariables>;
export function useBilanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BilanQuery, BilanQueryVariables>): Apollo.UseSuspenseQueryResult<BilanQuery | undefined, BilanQueryVariables>;
export function useBilanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BilanQuery, BilanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BilanQuery, BilanQueryVariables>(BilanDocument, options);
        }
export type BilanQueryHookResult = ReturnType<typeof useBilanQuery>;
export type BilanLazyQueryHookResult = ReturnType<typeof useBilanLazyQuery>;
export type BilanSuspenseQueryHookResult = ReturnType<typeof useBilanSuspenseQuery>;
export type BilanQueryResult = Apollo.QueryResult<BilanQuery, BilanQueryVariables>;
export const ComputeAccountsAmountsDocument = gql`
    mutation computeAccountsAmounts {
  computeAccountsAmount {
    accounts {
      id
      amount
      __typename
    }
    __typename
  }
}
    `;
export type ComputeAccountsAmountsMutationFn = Apollo.MutationFunction<ComputeAccountsAmountsMutation, ComputeAccountsAmountsMutationVariables>;

/**
 * __useComputeAccountsAmountsMutation__
 *
 * To run a mutation, you first call `useComputeAccountsAmountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeAccountsAmountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeAccountsAmountsMutation, { data, loading, error }] = useComputeAccountsAmountsMutation({
 *   variables: {
 *   },
 * });
 */
export function useComputeAccountsAmountsMutation(baseOptions?: Apollo.MutationHookOptions<ComputeAccountsAmountsMutation, ComputeAccountsAmountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ComputeAccountsAmountsMutation, ComputeAccountsAmountsMutationVariables>(ComputeAccountsAmountsDocument, options);
      }
export type ComputeAccountsAmountsMutationHookResult = ReturnType<typeof useComputeAccountsAmountsMutation>;
export type ComputeAccountsAmountsMutationResult = Apollo.MutationResult<ComputeAccountsAmountsMutation>;
export type ComputeAccountsAmountsMutationOptions = Apollo.BaseMutationOptions<ComputeAccountsAmountsMutation, ComputeAccountsAmountsMutationVariables>;
export const ComputeAllNextAutoTransactionsDocument = gql`
    mutation computeAllNextAutoTransactions {
  computeAllNextAutoTransactions {
    totalCount
  }
}
    `;
export type ComputeAllNextAutoTransactionsMutationFn = Apollo.MutationFunction<ComputeAllNextAutoTransactionsMutation, ComputeAllNextAutoTransactionsMutationVariables>;

/**
 * __useComputeAllNextAutoTransactionsMutation__
 *
 * To run a mutation, you first call `useComputeAllNextAutoTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeAllNextAutoTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeAllNextAutoTransactionsMutation, { data, loading, error }] = useComputeAllNextAutoTransactionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useComputeAllNextAutoTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<ComputeAllNextAutoTransactionsMutation, ComputeAllNextAutoTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ComputeAllNextAutoTransactionsMutation, ComputeAllNextAutoTransactionsMutationVariables>(ComputeAllNextAutoTransactionsDocument, options);
      }
export type ComputeAllNextAutoTransactionsMutationHookResult = ReturnType<typeof useComputeAllNextAutoTransactionsMutation>;
export type ComputeAllNextAutoTransactionsMutationResult = Apollo.MutationResult<ComputeAllNextAutoTransactionsMutation>;
export type ComputeAllNextAutoTransactionsMutationOptions = Apollo.BaseMutationOptions<ComputeAllNextAutoTransactionsMutation, ComputeAllNextAutoTransactionsMutationVariables>;
export const ComputeAverageGainDocument = gql`
    query computeAverageGain($stockId: ID!, $signalType: SignalType!) {
  computeAverageGain(stockId: $stockId, signalType: $signalType) {
    averageGain
    tradesCount
    gainPerYear
  }
}
    `;

/**
 * __useComputeAverageGainQuery__
 *
 * To run a query within a React component, call `useComputeAverageGainQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeAverageGainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeAverageGainQuery({
 *   variables: {
 *      stockId: // value for 'stockId'
 *      signalType: // value for 'signalType'
 *   },
 * });
 */
export function useComputeAverageGainQuery(baseOptions: Apollo.QueryHookOptions<ComputeAverageGainQuery, ComputeAverageGainQueryVariables> & ({ variables: ComputeAverageGainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>(ComputeAverageGainDocument, options);
      }
export function useComputeAverageGainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>(ComputeAverageGainDocument, options);
        }
// @ts-ignore
export function useComputeAverageGainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>): Apollo.UseSuspenseQueryResult<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>;
export function useComputeAverageGainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>): Apollo.UseSuspenseQueryResult<ComputeAverageGainQuery | undefined, ComputeAverageGainQueryVariables>;
export function useComputeAverageGainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>(ComputeAverageGainDocument, options);
        }
export type ComputeAverageGainQueryHookResult = ReturnType<typeof useComputeAverageGainQuery>;
export type ComputeAverageGainLazyQueryHookResult = ReturnType<typeof useComputeAverageGainLazyQuery>;
export type ComputeAverageGainSuspenseQueryHookResult = ReturnType<typeof useComputeAverageGainSuspenseQuery>;
export type ComputeAverageGainQueryResult = Apollo.QueryResult<ComputeAverageGainQuery, ComputeAverageGainQueryVariables>;
export const ComputeNextAutoTransactionsDocument = gql`
    mutation computeNextAutoTransactions {
  computeNextAutoTransactions {
    transactions {
      id
      __typename
    }
    __typename
  }
}
    `;
export type ComputeNextAutoTransactionsMutationFn = Apollo.MutationFunction<ComputeNextAutoTransactionsMutation, ComputeNextAutoTransactionsMutationVariables>;

/**
 * __useComputeNextAutoTransactionsMutation__
 *
 * To run a mutation, you first call `useComputeNextAutoTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeNextAutoTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeNextAutoTransactionsMutation, { data, loading, error }] = useComputeNextAutoTransactionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useComputeNextAutoTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<ComputeNextAutoTransactionsMutation, ComputeNextAutoTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ComputeNextAutoTransactionsMutation, ComputeNextAutoTransactionsMutationVariables>(ComputeNextAutoTransactionsDocument, options);
      }
export type ComputeNextAutoTransactionsMutationHookResult = ReturnType<typeof useComputeNextAutoTransactionsMutation>;
export type ComputeNextAutoTransactionsMutationResult = Apollo.MutationResult<ComputeNextAutoTransactionsMutation>;
export type ComputeNextAutoTransactionsMutationOptions = Apollo.BaseMutationOptions<ComputeNextAutoTransactionsMutation, ComputeNextAutoTransactionsMutationVariables>;
export const ComputeStatsDocument = gql`
    query computeStats($input: ChartDataInput) {
  chartData(input: $input) {
    contexts {
      year
      amount
      context {
        id
        name
      }
      post {
        id
        name
      }
      comment
    }
  }
}
    `;

/**
 * __useComputeStatsQuery__
 *
 * To run a query within a React component, call `useComputeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComputeStatsQuery(baseOptions?: Apollo.QueryHookOptions<ComputeStatsQuery, ComputeStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputeStatsQuery, ComputeStatsQueryVariables>(ComputeStatsDocument, options);
      }
export function useComputeStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputeStatsQuery, ComputeStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputeStatsQuery, ComputeStatsQueryVariables>(ComputeStatsDocument, options);
        }
// @ts-ignore
export function useComputeStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComputeStatsQuery, ComputeStatsQueryVariables>): Apollo.UseSuspenseQueryResult<ComputeStatsQuery, ComputeStatsQueryVariables>;
export function useComputeStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputeStatsQuery, ComputeStatsQueryVariables>): Apollo.UseSuspenseQueryResult<ComputeStatsQuery | undefined, ComputeStatsQueryVariables>;
export function useComputeStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputeStatsQuery, ComputeStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComputeStatsQuery, ComputeStatsQueryVariables>(ComputeStatsDocument, options);
        }
export type ComputeStatsQueryHookResult = ReturnType<typeof useComputeStatsQuery>;
export type ComputeStatsLazyQueryHookResult = ReturnType<typeof useComputeStatsLazyQuery>;
export type ComputeStatsSuspenseQueryHookResult = ReturnType<typeof useComputeStatsSuspenseQuery>;
export type ComputeStatsQueryResult = Apollo.QueryResult<ComputeStatsQuery, ComputeStatsQueryVariables>;
export const ConnectBankDocument = gql`
    mutation connectBank($budgetInsideClientID: String!, $budgetInsideClientCode: String!) {
  connectBank(
    budgetInsideClientCode: $budgetInsideClientCode
    budgetInsideClientID: $budgetInsideClientID
  ) {
    id
  }
}
    `;
export type ConnectBankMutationFn = Apollo.MutationFunction<ConnectBankMutation, ConnectBankMutationVariables>;

/**
 * __useConnectBankMutation__
 *
 * To run a mutation, you first call `useConnectBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectBankMutation, { data, loading, error }] = useConnectBankMutation({
 *   variables: {
 *      budgetInsideClientID: // value for 'budgetInsideClientID'
 *      budgetInsideClientCode: // value for 'budgetInsideClientCode'
 *   },
 * });
 */
export function useConnectBankMutation(baseOptions?: Apollo.MutationHookOptions<ConnectBankMutation, ConnectBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectBankMutation, ConnectBankMutationVariables>(ConnectBankDocument, options);
      }
export type ConnectBankMutationHookResult = ReturnType<typeof useConnectBankMutation>;
export type ConnectBankMutationResult = Apollo.MutationResult<ConnectBankMutation>;
export type ConnectBankMutationOptions = Apollo.BaseMutationOptions<ConnectBankMutation, ConnectBankMutationVariables>;
export const CreateAutomaticOperationDocument = gql`
    mutation createAutomaticOperation($nextDate: Date!, $credit: Int!, $debit: Int!, $monthDelta: Int!, $groupId: String!, $userId: String, $postId: String!, $contextId: String!, $accountId: String!, $comment: String!) {
  createAutomaticOperation(
    groupId: $groupId
    input: {nextDate: $nextDate, credit: $credit, debit: $debit, monthDelta: $monthDelta, userId: $userId, postId: $postId, contextId: $contextId, accountId: $accountId, comment: $comment}
  ) {
    id
    name
    automaticOperations {
      id
      credit
      debit
      comment
      nextDate
      monthDelta
      user {
        id
        firstname
      }
      account {
        id
        name
      }
      context {
        id
        name
      }
      post {
        id
        name
      }
    }
  }
}
    `;
export type CreateAutomaticOperationMutationFn = Apollo.MutationFunction<CreateAutomaticOperationMutation, CreateAutomaticOperationMutationVariables>;

/**
 * __useCreateAutomaticOperationMutation__
 *
 * To run a mutation, you first call `useCreateAutomaticOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomaticOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomaticOperationMutation, { data, loading, error }] = useCreateAutomaticOperationMutation({
 *   variables: {
 *      nextDate: // value for 'nextDate'
 *      credit: // value for 'credit'
 *      debit: // value for 'debit'
 *      monthDelta: // value for 'monthDelta'
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      postId: // value for 'postId'
 *      contextId: // value for 'contextId'
 *      accountId: // value for 'accountId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateAutomaticOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomaticOperationMutation, CreateAutomaticOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomaticOperationMutation, CreateAutomaticOperationMutationVariables>(CreateAutomaticOperationDocument, options);
      }
export type CreateAutomaticOperationMutationHookResult = ReturnType<typeof useCreateAutomaticOperationMutation>;
export type CreateAutomaticOperationMutationResult = Apollo.MutationResult<CreateAutomaticOperationMutation>;
export type CreateAutomaticOperationMutationOptions = Apollo.BaseMutationOptions<CreateAutomaticOperationMutation, CreateAutomaticOperationMutationVariables>;
export const CreateTransactionDocument = gql`
    mutation createTransaction($date: Date!, $credit: Int!, $debit: Int!, $groupId: String!, $userId: String, $postId: String!, $contextId: String!, $accountId: String!, $comment: String!, $checked: Boolean!) {
  createTransaction(
    input: {date: $date, credit: $credit, debit: $debit, groupId: $groupId, userId: $userId, postId: $postId, contextId: $contextId, accountId: $accountId, comment: $comment, checked: $checked}
  ) {
    __typename
    ...transactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      date: // value for 'date'
 *      credit: // value for 'credit'
 *      debit: // value for 'debit'
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      postId: // value for 'postId'
 *      contextId: // value for 'contextId'
 *      accountId: // value for 'accountId'
 *      comment: // value for 'comment'
 *      checked: // value for 'checked'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const CurrentUserAccountsDocument = gql`
    query currentUserAccounts {
  currentUser {
    id
    accounts {
      id
      name
      enabled
      amount
    }
  }
}
    `;

/**
 * __useCurrentUserAccountsQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>(CurrentUserAccountsDocument, options);
      }
export function useCurrentUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>(CurrentUserAccountsDocument, options);
        }
// @ts-ignore
export function useCurrentUserAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>;
export function useCurrentUserAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserAccountsQuery | undefined, CurrentUserAccountsQueryVariables>;
export function useCurrentUserAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>(CurrentUserAccountsDocument, options);
        }
export type CurrentUserAccountsQueryHookResult = ReturnType<typeof useCurrentUserAccountsQuery>;
export type CurrentUserAccountsLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountsLazyQuery>;
export type CurrentUserAccountsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountsSuspenseQuery>;
export type CurrentUserAccountsQueryResult = Apollo.QueryResult<CurrentUserAccountsQuery, CurrentUserAccountsQueryVariables>;
export const CurrentUserAccountsDetailsDocument = gql`
    query currentUserAccountsDetails {
  currentUser {
    id
    firstname
    accounts {
      id
      amount
      name
      type
      enabled
      hasTransactions
      bankAccount {
        id
      }
    }
  }
  banksOfUser {
    id
    name
    status
    accounts {
      name
      id
    }
  }
  groups {
    id
    name
    accounts {
      id
      amount
      name
      type
      enabled
      hasTransactions
      bankAccount {
        id
      }
    }
  }
}
    `;

/**
 * __useCurrentUserAccountsDetailsQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountsDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountsDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>(CurrentUserAccountsDetailsDocument, options);
      }
export function useCurrentUserAccountsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>(CurrentUserAccountsDetailsDocument, options);
        }
// @ts-ignore
export function useCurrentUserAccountsDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>;
export function useCurrentUserAccountsDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserAccountsDetailsQuery | undefined, CurrentUserAccountsDetailsQueryVariables>;
export function useCurrentUserAccountsDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>(CurrentUserAccountsDetailsDocument, options);
        }
export type CurrentUserAccountsDetailsQueryHookResult = ReturnType<typeof useCurrentUserAccountsDetailsQuery>;
export type CurrentUserAccountsDetailsLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountsDetailsLazyQuery>;
export type CurrentUserAccountsDetailsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountsDetailsSuspenseQuery>;
export type CurrentUserAccountsDetailsQueryResult = Apollo.QueryResult<CurrentUserAccountsDetailsQuery, CurrentUserAccountsDetailsQueryVariables>;
export const CurrentUserStocksDocument = gql`
    query currentUserStocks {
  currentUser {
    stocks(follow: true) {
      id
      signals {
        id
        rsi {
          id
          lastEvent {
            id
            date
            cause
            type
            buyValue
            sellValue
          }
          lastComputedAt
        }
        sma {
          id
          lastEvent {
            id
            date
            cause
            type
            buyValue
            sellValue
          }
          lastComputedAt
        }
      }
      stock {
        id
        symbol
        name
        historical2(first: 2) {
          edges {
            node {
              close
              date
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentUserStocksQuery__
 *
 * To run a query within a React component, call `useCurrentUserStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserStocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserStocksQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>(CurrentUserStocksDocument, options);
      }
export function useCurrentUserStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>(CurrentUserStocksDocument, options);
        }
// @ts-ignore
export function useCurrentUserStocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>;
export function useCurrentUserStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserStocksQuery | undefined, CurrentUserStocksQueryVariables>;
export function useCurrentUserStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>(CurrentUserStocksDocument, options);
        }
export type CurrentUserStocksQueryHookResult = ReturnType<typeof useCurrentUserStocksQuery>;
export type CurrentUserStocksLazyQueryHookResult = ReturnType<typeof useCurrentUserStocksLazyQuery>;
export type CurrentUserStocksSuspenseQueryHookResult = ReturnType<typeof useCurrentUserStocksSuspenseQuery>;
export type CurrentUserStocksQueryResult = Apollo.QueryResult<CurrentUserStocksQuery, CurrentUserStocksQueryVariables>;
export const DeleteAutomaticOperationDocument = gql`
    mutation deleteAutomaticOperation($id: String!, $groupId: String!) {
  deleteAutomaticOperation(id: $id, groupId: $groupId) {
    id
    name
    automaticOperations {
      id
      credit
      debit
      comment
      nextDate
      monthDelta
      user {
        id
        firstname
      }
      account {
        id
        name
      }
      context {
        id
        name
      }
      post {
        id
        name
      }
    }
  }
}
    `;
export type DeleteAutomaticOperationMutationFn = Apollo.MutationFunction<DeleteAutomaticOperationMutation, DeleteAutomaticOperationMutationVariables>;

/**
 * __useDeleteAutomaticOperationMutation__
 *
 * To run a mutation, you first call `useDeleteAutomaticOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomaticOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomaticOperationMutation, { data, loading, error }] = useDeleteAutomaticOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteAutomaticOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomaticOperationMutation, DeleteAutomaticOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomaticOperationMutation, DeleteAutomaticOperationMutationVariables>(DeleteAutomaticOperationDocument, options);
      }
export type DeleteAutomaticOperationMutationHookResult = ReturnType<typeof useDeleteAutomaticOperationMutation>;
export type DeleteAutomaticOperationMutationResult = Apollo.MutationResult<DeleteAutomaticOperationMutation>;
export type DeleteAutomaticOperationMutationOptions = Apollo.BaseMutationOptions<DeleteAutomaticOperationMutation, DeleteAutomaticOperationMutationVariables>;
export const DeleteGroupAccountDocument = gql`
    mutation deleteGroupAccount($groupId: String!, $accountId: String!) {
  deleteGroupAccount(groupId: $groupId, accountId: $accountId) {
    id
    accounts {
      id
      name
      hasTransactions
    }
  }
}
    `;
export type DeleteGroupAccountMutationFn = Apollo.MutationFunction<DeleteGroupAccountMutation, DeleteGroupAccountMutationVariables>;

/**
 * __useDeleteGroupAccountMutation__
 *
 * To run a mutation, you first call `useDeleteGroupAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupAccountMutation, { data, loading, error }] = useDeleteGroupAccountMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteGroupAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupAccountMutation, DeleteGroupAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupAccountMutation, DeleteGroupAccountMutationVariables>(DeleteGroupAccountDocument, options);
      }
export type DeleteGroupAccountMutationHookResult = ReturnType<typeof useDeleteGroupAccountMutation>;
export type DeleteGroupAccountMutationResult = Apollo.MutationResult<DeleteGroupAccountMutation>;
export type DeleteGroupAccountMutationOptions = Apollo.BaseMutationOptions<DeleteGroupAccountMutation, DeleteGroupAccountMutationVariables>;
export const DeleteStatDocument = gql`
    mutation deleteStat($id: ID!) {
  deleteStat(id: $id) {
    ...userStats
  }
}
    ${UserStatsFragmentDoc}`;
export type DeleteStatMutationFn = Apollo.MutationFunction<DeleteStatMutation, DeleteStatMutationVariables>;

/**
 * __useDeleteStatMutation__
 *
 * To run a mutation, you first call `useDeleteStatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStatMutation, { data, loading, error }] = useDeleteStatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStatMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStatMutation, DeleteStatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStatMutation, DeleteStatMutationVariables>(DeleteStatDocument, options);
      }
export type DeleteStatMutationHookResult = ReturnType<typeof useDeleteStatMutation>;
export type DeleteStatMutationResult = Apollo.MutationResult<DeleteStatMutation>;
export type DeleteStatMutationOptions = Apollo.BaseMutationOptions<DeleteStatMutation, DeleteStatMutationVariables>;
export const DeleteTransactionDocument = gql`
    mutation deleteTransaction($id: String!) {
  deleteTransaction(id: $id) {
    __typename
    ...transactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;
export type DeleteTransactionMutationFn = Apollo.MutationFunction<DeleteTransactionMutation, DeleteTransactionMutationVariables>;

/**
 * __useDeleteTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionMutation, { data, loading, error }] = useDeleteTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionMutation, DeleteTransactionMutationVariables>(DeleteTransactionDocument, options);
      }
export type DeleteTransactionMutationHookResult = ReturnType<typeof useDeleteTransactionMutation>;
export type DeleteTransactionMutationResult = Apollo.MutationResult<DeleteTransactionMutation>;
export type DeleteTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>;
export const DeleteUserAccountDocument = gql`
    mutation deleteUserAccount($userId: String!, $accountId: String!) {
  deleteUserAccount(userId: $userId, accountId: $accountId) {
    id
    accounts {
      id
      name
      hasTransactions
    }
  }
}
    `;
export type DeleteUserAccountMutationFn = Apollo.MutationFunction<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;

/**
 * __useDeleteUserAccountMutation__
 *
 * To run a mutation, you first call `useDeleteUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAccountMutation, { data, loading, error }] = useDeleteUserAccountMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, options);
      }
export type DeleteUserAccountMutationHookResult = ReturnType<typeof useDeleteUserAccountMutation>;
export type DeleteUserAccountMutationResult = Apollo.MutationResult<DeleteUserAccountMutation>;
export type DeleteUserAccountMutationOptions = Apollo.BaseMutationOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;
export const EditAutomaticOperationDocument = gql`
    mutation editAutomaticOperation($id: String!, $nextDate: Date!, $credit: Int!, $debit: Int!, $monthDelta: Int!, $groupId: String!, $userId: String, $postId: String!, $contextId: String!, $accountId: String!, $comment: String!) {
  editAutomaticOperation(
    groupId: $groupId
    input: {id: $id, nextDate: $nextDate, credit: $credit, debit: $debit, monthDelta: $monthDelta, userId: $userId, postId: $postId, contextId: $contextId, accountId: $accountId, comment: $comment}
  ) {
    id
    name
    automaticOperations {
      id
      credit
      debit
      comment
      nextDate
      monthDelta
      user {
        id
        firstname
      }
      account {
        id
        name
      }
      context {
        id
        name
      }
      post {
        id
        name
      }
    }
  }
}
    `;
export type EditAutomaticOperationMutationFn = Apollo.MutationFunction<EditAutomaticOperationMutation, EditAutomaticOperationMutationVariables>;

/**
 * __useEditAutomaticOperationMutation__
 *
 * To run a mutation, you first call `useEditAutomaticOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAutomaticOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAutomaticOperationMutation, { data, loading, error }] = useEditAutomaticOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nextDate: // value for 'nextDate'
 *      credit: // value for 'credit'
 *      debit: // value for 'debit'
 *      monthDelta: // value for 'monthDelta'
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      postId: // value for 'postId'
 *      contextId: // value for 'contextId'
 *      accountId: // value for 'accountId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useEditAutomaticOperationMutation(baseOptions?: Apollo.MutationHookOptions<EditAutomaticOperationMutation, EditAutomaticOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAutomaticOperationMutation, EditAutomaticOperationMutationVariables>(EditAutomaticOperationDocument, options);
      }
export type EditAutomaticOperationMutationHookResult = ReturnType<typeof useEditAutomaticOperationMutation>;
export type EditAutomaticOperationMutationResult = Apollo.MutationResult<EditAutomaticOperationMutation>;
export type EditAutomaticOperationMutationOptions = Apollo.BaseMutationOptions<EditAutomaticOperationMutation, EditAutomaticOperationMutationVariables>;
export const EditContextDocument = gql`
    mutation editContext($groupId: ID!, $contextId: String!, $name: String!, $enabled: Boolean!) {
  editContext(
    groupId: $groupId
    contextId: $contextId
    name: $name
    enabled: $enabled
  ) {
    id
    contexts {
      id
      name
      enabled
      posts {
        id
        name
        enabled
      }
    }
  }
}
    `;
export type EditContextMutationFn = Apollo.MutationFunction<EditContextMutation, EditContextMutationVariables>;

/**
 * __useEditContextMutation__
 *
 * To run a mutation, you first call `useEditContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContextMutation, { data, loading, error }] = useEditContextMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      contextId: // value for 'contextId'
 *      name: // value for 'name'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEditContextMutation(baseOptions?: Apollo.MutationHookOptions<EditContextMutation, EditContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContextMutation, EditContextMutationVariables>(EditContextDocument, options);
      }
export type EditContextMutationHookResult = ReturnType<typeof useEditContextMutation>;
export type EditContextMutationResult = Apollo.MutationResult<EditContextMutation>;
export type EditContextMutationOptions = Apollo.BaseMutationOptions<EditContextMutation, EditContextMutationVariables>;
export const EditGroupAccountDocument = gql`
    mutation editGroupAccount($groupId: String!, $account: AccountInput!) {
  editGroupAccount(groupId: $groupId, account: $account) {
    id
  }
}
    `;
export type EditGroupAccountMutationFn = Apollo.MutationFunction<EditGroupAccountMutation, EditGroupAccountMutationVariables>;

/**
 * __useEditGroupAccountMutation__
 *
 * To run a mutation, you first call `useEditGroupAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGroupAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGroupAccountMutation, { data, loading, error }] = useEditGroupAccountMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useEditGroupAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditGroupAccountMutation, EditGroupAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGroupAccountMutation, EditGroupAccountMutationVariables>(EditGroupAccountDocument, options);
      }
export type EditGroupAccountMutationHookResult = ReturnType<typeof useEditGroupAccountMutation>;
export type EditGroupAccountMutationResult = Apollo.MutationResult<EditGroupAccountMutation>;
export type EditGroupAccountMutationOptions = Apollo.BaseMutationOptions<EditGroupAccountMutation, EditGroupAccountMutationVariables>;
export const EditPostDocument = gql`
    mutation editPost($groupId: ID!, $contextId: String!, $postId: ID!, $name: String!, $enabled: Boolean!) {
  editPost(
    groupId: $groupId
    contextId: $contextId
    postId: $postId
    name: $name
    enabled: $enabled
  ) {
    id
    contexts {
      id
      name
      enabled
      posts {
        id
        name
        enabled
      }
    }
  }
}
    `;
export type EditPostMutationFn = Apollo.MutationFunction<EditPostMutation, EditPostMutationVariables>;

/**
 * __useEditPostMutation__
 *
 * To run a mutation, you first call `useEditPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPostMutation, { data, loading, error }] = useEditPostMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      contextId: // value for 'contextId'
 *      postId: // value for 'postId'
 *      name: // value for 'name'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEditPostMutation(baseOptions?: Apollo.MutationHookOptions<EditPostMutation, EditPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPostMutation, EditPostMutationVariables>(EditPostDocument, options);
      }
export type EditPostMutationHookResult = ReturnType<typeof useEditPostMutation>;
export type EditPostMutationResult = Apollo.MutationResult<EditPostMutation>;
export type EditPostMutationOptions = Apollo.BaseMutationOptions<EditPostMutation, EditPostMutationVariables>;
export const EditStatDocument = gql`
    mutation editStat($id: ID!, $stat: StatInput!) {
  editStat(id: $id, stat: $stat) {
    ...userStats
  }
}
    ${UserStatsFragmentDoc}`;
export type EditStatMutationFn = Apollo.MutationFunction<EditStatMutation, EditStatMutationVariables>;

/**
 * __useEditStatMutation__
 *
 * To run a mutation, you first call `useEditStatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStatMutation, { data, loading, error }] = useEditStatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stat: // value for 'stat'
 *   },
 * });
 */
export function useEditStatMutation(baseOptions?: Apollo.MutationHookOptions<EditStatMutation, EditStatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStatMutation, EditStatMutationVariables>(EditStatDocument, options);
      }
export type EditStatMutationHookResult = ReturnType<typeof useEditStatMutation>;
export type EditStatMutationResult = Apollo.MutationResult<EditStatMutation>;
export type EditStatMutationOptions = Apollo.BaseMutationOptions<EditStatMutation, EditStatMutationVariables>;
export const EditTransactionDocument = gql`
    mutation editTransaction($id: String!, $date: Date!, $credit: Int!, $debit: Int!, $groupId: String!, $userId: String, $postId: String!, $contextId: String!, $accountId: String!, $comment: String!, $checked: Boolean!) {
  editTransaction(
    input: {id: $id, date: $date, credit: $credit, debit: $debit, groupId: $groupId, userId: $userId, postId: $postId, contextId: $contextId, accountId: $accountId, comment: $comment, checked: $checked}
  ) {
    __typename
    ...transactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;
export type EditTransactionMutationFn = Apollo.MutationFunction<EditTransactionMutation, EditTransactionMutationVariables>;

/**
 * __useEditTransactionMutation__
 *
 * To run a mutation, you first call `useEditTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTransactionMutation, { data, loading, error }] = useEditTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      credit: // value for 'credit'
 *      debit: // value for 'debit'
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      postId: // value for 'postId'
 *      contextId: // value for 'contextId'
 *      accountId: // value for 'accountId'
 *      comment: // value for 'comment'
 *      checked: // value for 'checked'
 *   },
 * });
 */
export function useEditTransactionMutation(baseOptions?: Apollo.MutationHookOptions<EditTransactionMutation, EditTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTransactionMutation, EditTransactionMutationVariables>(EditTransactionDocument, options);
      }
export type EditTransactionMutationHookResult = ReturnType<typeof useEditTransactionMutation>;
export type EditTransactionMutationResult = Apollo.MutationResult<EditTransactionMutation>;
export type EditTransactionMutationOptions = Apollo.BaseMutationOptions<EditTransactionMutation, EditTransactionMutationVariables>;
export const EditUserAccountDocument = gql`
    mutation editUserAccount($userId: String!, $account: AccountInput!) {
  editUserAccount(userId: $userId, account: $account) {
    id
  }
}
    `;
export type EditUserAccountMutationFn = Apollo.MutationFunction<EditUserAccountMutation, EditUserAccountMutationVariables>;

/**
 * __useEditUserAccountMutation__
 *
 * To run a mutation, you first call `useEditUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserAccountMutation, { data, loading, error }] = useEditUserAccountMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useEditUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditUserAccountMutation, EditUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserAccountMutation, EditUserAccountMutationVariables>(EditUserAccountDocument, options);
      }
export type EditUserAccountMutationHookResult = ReturnType<typeof useEditUserAccountMutation>;
export type EditUserAccountMutationResult = Apollo.MutationResult<EditUserAccountMutation>;
export type EditUserAccountMutationOptions = Apollo.BaseMutationOptions<EditUserAccountMutation, EditUserAccountMutationVariables>;
export const FollowStockDocument = gql`
    mutation followStock($stockId: ID!) {
  followStock(stockId: $stockId) {
    id
    stocks {
      id
      stock {
        id
        currentUser {
          id
          follow
        }
      }
    }
  }
}
    `;
export type FollowStockMutationFn = Apollo.MutationFunction<FollowStockMutation, FollowStockMutationVariables>;

/**
 * __useFollowStockMutation__
 *
 * To run a mutation, you first call `useFollowStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followStockMutation, { data, loading, error }] = useFollowStockMutation({
 *   variables: {
 *      stockId: // value for 'stockId'
 *   },
 * });
 */
export function useFollowStockMutation(baseOptions?: Apollo.MutationHookOptions<FollowStockMutation, FollowStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowStockMutation, FollowStockMutationVariables>(FollowStockDocument, options);
      }
export type FollowStockMutationHookResult = ReturnType<typeof useFollowStockMutation>;
export type FollowStockMutationResult = Apollo.MutationResult<FollowStockMutation>;
export type FollowStockMutationOptions = Apollo.BaseMutationOptions<FollowStockMutation, FollowStockMutationVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  user(id: $id) {
    id
    lastname
    groups {
      id
      name
    }
    stats {
      id
      contexts {
        id
        post {
          id
          name
        }
        context {
          id
          name
        }
      }
    }
    accounts {
      id
      name
      type
      enabled
      amount
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    id
    lastname
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetGroupsDetailsDocument = gql`
    query getGroupsDetails {
  groups {
    id
    name
    contexts {
      id
      name
      enabled
      posts {
        id
        name
        enabled
      }
    }
  }
}
    `;

/**
 * __useGetGroupsDetailsQuery__
 *
 * To run a query within a React component, call `useGetGroupsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupsDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>(GetGroupsDetailsDocument, options);
      }
export function useGetGroupsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>(GetGroupsDetailsDocument, options);
        }
// @ts-ignore
export function useGetGroupsDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>;
export function useGetGroupsDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsDetailsQuery | undefined, GetGroupsDetailsQueryVariables>;
export function useGetGroupsDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>(GetGroupsDetailsDocument, options);
        }
export type GetGroupsDetailsQueryHookResult = ReturnType<typeof useGetGroupsDetailsQuery>;
export type GetGroupsDetailsLazyQueryHookResult = ReturnType<typeof useGetGroupsDetailsLazyQuery>;
export type GetGroupsDetailsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsDetailsSuspenseQuery>;
export type GetGroupsDetailsQueryResult = Apollo.QueryResult<GetGroupsDetailsQuery, GetGroupsDetailsQueryVariables>;
export const LinkBankAccountToAccountDocument = gql`
    mutation linkBankAccountToAccount($budgetInsideBankAccount: String!, $accountId: ID!) {
  linkBankAccountToAccount(
    budgetInsideBankAccount: $budgetInsideBankAccount
    accountId: $accountId
  ) {
    id
    name
    enabled
    type
    amount
    bankAccount {
      id
    }
  }
}
    `;
export type LinkBankAccountToAccountMutationFn = Apollo.MutationFunction<LinkBankAccountToAccountMutation, LinkBankAccountToAccountMutationVariables>;

/**
 * __useLinkBankAccountToAccountMutation__
 *
 * To run a mutation, you first call `useLinkBankAccountToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkBankAccountToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkBankAccountToAccountMutation, { data, loading, error }] = useLinkBankAccountToAccountMutation({
 *   variables: {
 *      budgetInsideBankAccount: // value for 'budgetInsideBankAccount'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useLinkBankAccountToAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkBankAccountToAccountMutation, LinkBankAccountToAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkBankAccountToAccountMutation, LinkBankAccountToAccountMutationVariables>(LinkBankAccountToAccountDocument, options);
      }
export type LinkBankAccountToAccountMutationHookResult = ReturnType<typeof useLinkBankAccountToAccountMutation>;
export type LinkBankAccountToAccountMutationResult = Apollo.MutationResult<LinkBankAccountToAccountMutation>;
export type LinkBankAccountToAccountMutationOptions = Apollo.BaseMutationOptions<LinkBankAccountToAccountMutation, LinkBankAccountToAccountMutationVariables>;
export const OptimizeRsiSignalDocument = gql`
    mutation optimizeRsiSignal($stockId: ID!) {
  optimizeRsiSignal(stockId: $stockId) {
    buySignal
    sellSignal
    stopLoss
    gain
  }
}
    `;
export type OptimizeRsiSignalMutationFn = Apollo.MutationFunction<OptimizeRsiSignalMutation, OptimizeRsiSignalMutationVariables>;

/**
 * __useOptimizeRsiSignalMutation__
 *
 * To run a mutation, you first call `useOptimizeRsiSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeRsiSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeRsiSignalMutation, { data, loading, error }] = useOptimizeRsiSignalMutation({
 *   variables: {
 *      stockId: // value for 'stockId'
 *   },
 * });
 */
export function useOptimizeRsiSignalMutation(baseOptions?: Apollo.MutationHookOptions<OptimizeRsiSignalMutation, OptimizeRsiSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptimizeRsiSignalMutation, OptimizeRsiSignalMutationVariables>(OptimizeRsiSignalDocument, options);
      }
export type OptimizeRsiSignalMutationHookResult = ReturnType<typeof useOptimizeRsiSignalMutation>;
export type OptimizeRsiSignalMutationResult = Apollo.MutationResult<OptimizeRsiSignalMutation>;
export type OptimizeRsiSignalMutationOptions = Apollo.BaseMutationOptions<OptimizeRsiSignalMutation, OptimizeRsiSignalMutationVariables>;
export const PowensWebviewCodeDocument = gql`
    query powensWebviewCode {
  powensWebviewCode
}
    `;

/**
 * __usePowensWebviewCodeQuery__
 *
 * To run a query within a React component, call `usePowensWebviewCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowensWebviewCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowensWebviewCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePowensWebviewCodeQuery(baseOptions?: Apollo.QueryHookOptions<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>(PowensWebviewCodeDocument, options);
      }
export function usePowensWebviewCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>(PowensWebviewCodeDocument, options);
        }
// @ts-ignore
export function usePowensWebviewCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>): Apollo.UseSuspenseQueryResult<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>;
export function usePowensWebviewCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>): Apollo.UseSuspenseQueryResult<PowensWebviewCodeQuery | undefined, PowensWebviewCodeQueryVariables>;
export function usePowensWebviewCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>(PowensWebviewCodeDocument, options);
        }
export type PowensWebviewCodeQueryHookResult = ReturnType<typeof usePowensWebviewCodeQuery>;
export type PowensWebviewCodeLazyQueryHookResult = ReturnType<typeof usePowensWebviewCodeLazyQuery>;
export type PowensWebviewCodeSuspenseQueryHookResult = ReturnType<typeof usePowensWebviewCodeSuspenseQuery>;
export type PowensWebviewCodeQueryResult = Apollo.QueryResult<PowensWebviewCodeQuery, PowensWebviewCodeQueryVariables>;
export const RefetchRandomStocksDocument = gql`
    mutation refetchRandomStocks {
  refetchRandomStocks {
    id
  }
}
    `;
export type RefetchRandomStocksMutationFn = Apollo.MutationFunction<RefetchRandomStocksMutation, RefetchRandomStocksMutationVariables>;

/**
 * __useRefetchRandomStocksMutation__
 *
 * To run a mutation, you first call `useRefetchRandomStocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchRandomStocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchRandomStocksMutation, { data, loading, error }] = useRefetchRandomStocksMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefetchRandomStocksMutation(baseOptions?: Apollo.MutationHookOptions<RefetchRandomStocksMutation, RefetchRandomStocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchRandomStocksMutation, RefetchRandomStocksMutationVariables>(RefetchRandomStocksDocument, options);
      }
export type RefetchRandomStocksMutationHookResult = ReturnType<typeof useRefetchRandomStocksMutation>;
export type RefetchRandomStocksMutationResult = Apollo.MutationResult<RefetchRandomStocksMutation>;
export type RefetchRandomStocksMutationOptions = Apollo.BaseMutationOptions<RefetchRandomStocksMutation, RefetchRandomStocksMutationVariables>;
export const RefetchStockDataDocument = gql`
    mutation refetchStockData($id: String!) {
  refetchStockData(id: $id) {
    id
    historical2(first: 2) {
      edges {
        node {
          date
          close
        }
      }
    }
  }
}
    `;
export type RefetchStockDataMutationFn = Apollo.MutationFunction<RefetchStockDataMutation, RefetchStockDataMutationVariables>;

/**
 * __useRefetchStockDataMutation__
 *
 * To run a mutation, you first call `useRefetchStockDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchStockDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchStockDataMutation, { data, loading, error }] = useRefetchStockDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefetchStockDataMutation(baseOptions?: Apollo.MutationHookOptions<RefetchStockDataMutation, RefetchStockDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchStockDataMutation, RefetchStockDataMutationVariables>(RefetchStockDataDocument, options);
      }
export type RefetchStockDataMutationHookResult = ReturnType<typeof useRefetchStockDataMutation>;
export type RefetchStockDataMutationResult = Apollo.MutationResult<RefetchStockDataMutation>;
export type RefetchStockDataMutationOptions = Apollo.BaseMutationOptions<RefetchStockDataMutation, RefetchStockDataMutationVariables>;
export const RefetchStockDatasDocument = gql`
    mutation refetchStockDatas {
  refetchStockDatas {
    id
    symbol
  }
}
    `;
export type RefetchStockDatasMutationFn = Apollo.MutationFunction<RefetchStockDatasMutation, RefetchStockDatasMutationVariables>;

/**
 * __useRefetchStockDatasMutation__
 *
 * To run a mutation, you first call `useRefetchStockDatasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchStockDatasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchStockDatasMutation, { data, loading, error }] = useRefetchStockDatasMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefetchStockDatasMutation(baseOptions?: Apollo.MutationHookOptions<RefetchStockDatasMutation, RefetchStockDatasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchStockDatasMutation, RefetchStockDatasMutationVariables>(RefetchStockDatasDocument, options);
      }
export type RefetchStockDatasMutationHookResult = ReturnType<typeof useRefetchStockDatasMutation>;
export type RefetchStockDatasMutationResult = Apollo.MutationResult<RefetchStockDatasMutation>;
export type RefetchStockDatasMutationOptions = Apollo.BaseMutationOptions<RefetchStockDatasMutation, RefetchStockDatasMutationVariables>;
export const ResetAllPowensDataDocument = gql`
    mutation resetAllPowensData {
  resetAllPowensData
}
    `;
export type ResetAllPowensDataMutationFn = Apollo.MutationFunction<ResetAllPowensDataMutation, ResetAllPowensDataMutationVariables>;

/**
 * __useResetAllPowensDataMutation__
 *
 * To run a mutation, you first call `useResetAllPowensDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAllPowensDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAllPowensDataMutation, { data, loading, error }] = useResetAllPowensDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetAllPowensDataMutation(baseOptions?: Apollo.MutationHookOptions<ResetAllPowensDataMutation, ResetAllPowensDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAllPowensDataMutation, ResetAllPowensDataMutationVariables>(ResetAllPowensDataDocument, options);
      }
export type ResetAllPowensDataMutationHookResult = ReturnType<typeof useResetAllPowensDataMutation>;
export type ResetAllPowensDataMutationResult = Apollo.MutationResult<ResetAllPowensDataMutation>;
export type ResetAllPowensDataMutationOptions = Apollo.BaseMutationOptions<ResetAllPowensDataMutation, ResetAllPowensDataMutationVariables>;
export const RestoreTransactionDocument = gql`
    mutation restoreTransaction($id: String!) {
  restoreTransaction(id: $id) {
    __typename
    ...transactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;
export type RestoreTransactionMutationFn = Apollo.MutationFunction<RestoreTransactionMutation, RestoreTransactionMutationVariables>;

/**
 * __useRestoreTransactionMutation__
 *
 * To run a mutation, you first call `useRestoreTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTransactionMutation, { data, loading, error }] = useRestoreTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreTransactionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTransactionMutation, RestoreTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTransactionMutation, RestoreTransactionMutationVariables>(RestoreTransactionDocument, options);
      }
export type RestoreTransactionMutationHookResult = ReturnType<typeof useRestoreTransactionMutation>;
export type RestoreTransactionMutationResult = Apollo.MutationResult<RestoreTransactionMutation>;
export type RestoreTransactionMutationOptions = Apollo.BaseMutationOptions<RestoreTransactionMutation, RestoreTransactionMutationVariables>;
export const SignalTradeHistoryDocument = gql`
    query signalTradeHistory($stockId: ID!, $signalType: SignalType!) {
  signalTradeHistory(stockId: $stockId, signalType: $signalType) {
    buyDate
    buyValue
    sellDate
    sellValue
    gainPercent
    cause
  }
}
    `;

/**
 * __useSignalTradeHistoryQuery__
 *
 * To run a query within a React component, call `useSignalTradeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalTradeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalTradeHistoryQuery({
 *   variables: {
 *      stockId: // value for 'stockId'
 *      signalType: // value for 'signalType'
 *   },
 * });
 */
export function useSignalTradeHistoryQuery(baseOptions: Apollo.QueryHookOptions<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables> & ({ variables: SignalTradeHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>(SignalTradeHistoryDocument, options);
      }
export function useSignalTradeHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>(SignalTradeHistoryDocument, options);
        }
// @ts-ignore
export function useSignalTradeHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>;
export function useSignalTradeHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<SignalTradeHistoryQuery | undefined, SignalTradeHistoryQueryVariables>;
export function useSignalTradeHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>(SignalTradeHistoryDocument, options);
        }
export type SignalTradeHistoryQueryHookResult = ReturnType<typeof useSignalTradeHistoryQuery>;
export type SignalTradeHistoryLazyQueryHookResult = ReturnType<typeof useSignalTradeHistoryLazyQuery>;
export type SignalTradeHistorySuspenseQueryHookResult = ReturnType<typeof useSignalTradeHistorySuspenseQuery>;
export type SignalTradeHistoryQueryResult = Apollo.QueryResult<SignalTradeHistoryQuery, SignalTradeHistoryQueryVariables>;
export const ChartConfigsDocument = gql`
    query chartConfigs {
  groups {
    id
    contexts {
      id
      name
      posts {
        id
        name
      }
    }
  }
  currentUser {
    ...userStats
  }
}
    ${UserStatsFragmentDoc}`;

/**
 * __useChartConfigsQuery__
 *
 * To run a query within a React component, call `useChartConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChartConfigsQuery(baseOptions?: Apollo.QueryHookOptions<ChartConfigsQuery, ChartConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartConfigsQuery, ChartConfigsQueryVariables>(ChartConfigsDocument, options);
      }
export function useChartConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartConfigsQuery, ChartConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartConfigsQuery, ChartConfigsQueryVariables>(ChartConfigsDocument, options);
        }
// @ts-ignore
export function useChartConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChartConfigsQuery, ChartConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<ChartConfigsQuery, ChartConfigsQueryVariables>;
export function useChartConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChartConfigsQuery, ChartConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<ChartConfigsQuery | undefined, ChartConfigsQueryVariables>;
export function useChartConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChartConfigsQuery, ChartConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChartConfigsQuery, ChartConfigsQueryVariables>(ChartConfigsDocument, options);
        }
export type ChartConfigsQueryHookResult = ReturnType<typeof useChartConfigsQuery>;
export type ChartConfigsLazyQueryHookResult = ReturnType<typeof useChartConfigsLazyQuery>;
export type ChartConfigsSuspenseQueryHookResult = ReturnType<typeof useChartConfigsSuspenseQuery>;
export type ChartConfigsQueryResult = Apollo.QueryResult<ChartConfigsQuery, ChartConfigsQueryVariables>;
export const GetStockDocument = gql`
    query getStock($id: ID!) {
  stock(id: $id) {
    id
    symbol
  }
}
    `;

/**
 * __useGetStockQuery__
 *
 * To run a query within a React component, call `useGetStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStockQuery(baseOptions: Apollo.QueryHookOptions<GetStockQuery, GetStockQueryVariables> & ({ variables: GetStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockQuery, GetStockQueryVariables>(GetStockDocument, options);
      }
export function useGetStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockQuery, GetStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockQuery, GetStockQueryVariables>(GetStockDocument, options);
        }
// @ts-ignore
export function useGetStockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockQuery, GetStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockQuery, GetStockQueryVariables>;
export function useGetStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockQuery, GetStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockQuery | undefined, GetStockQueryVariables>;
export function useGetStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockQuery, GetStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockQuery, GetStockQueryVariables>(GetStockDocument, options);
        }
export type GetStockQueryHookResult = ReturnType<typeof useGetStockQuery>;
export type GetStockLazyQueryHookResult = ReturnType<typeof useGetStockLazyQuery>;
export type GetStockSuspenseQueryHookResult = ReturnType<typeof useGetStockSuspenseQuery>;
export type GetStockQueryResult = Apollo.QueryResult<GetStockQuery, GetStockQueryVariables>;
export const StockDetailDocument = gql`
    query stockDetail($id: ID!) {
  stock(id: $id) {
    id
    name
    currentUser {
      id
      signals {
        id
        rsi {
          id
          buySignal
          sellSignal
          stopLoss
          maxBuys
          lastEvent {
            id
            date
            cause
            type
            buyValue
            sellValue
          }
          lastComputedAt
        }
        sma {
          id
          usedSma
          buyTrend
          daysInBuyTrend
          sellTrend
          daysInSellTrend
          maxBuys
          stopLoss
          lastComputedAt
        }
      }
    }
    historical2 {
      edges {
        node {
          date
          adjClose
          rsi14
          low
        }
      }
    }
  }
}
    `;

/**
 * __useStockDetailQuery__
 *
 * To run a query within a React component, call `useStockDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStockDetailQuery(baseOptions: Apollo.QueryHookOptions<StockDetailQuery, StockDetailQueryVariables> & ({ variables: StockDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockDetailQuery, StockDetailQueryVariables>(StockDetailDocument, options);
      }
export function useStockDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockDetailQuery, StockDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockDetailQuery, StockDetailQueryVariables>(StockDetailDocument, options);
        }
// @ts-ignore
export function useStockDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StockDetailQuery, StockDetailQueryVariables>): Apollo.UseSuspenseQueryResult<StockDetailQuery, StockDetailQueryVariables>;
export function useStockDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockDetailQuery, StockDetailQueryVariables>): Apollo.UseSuspenseQueryResult<StockDetailQuery | undefined, StockDetailQueryVariables>;
export function useStockDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockDetailQuery, StockDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StockDetailQuery, StockDetailQueryVariables>(StockDetailDocument, options);
        }
export type StockDetailQueryHookResult = ReturnType<typeof useStockDetailQuery>;
export type StockDetailLazyQueryHookResult = ReturnType<typeof useStockDetailLazyQuery>;
export type StockDetailSuspenseQueryHookResult = ReturnType<typeof useStockDetailSuspenseQuery>;
export type StockDetailQueryResult = Apollo.QueryResult<StockDetailQuery, StockDetailQueryVariables>;
export const GetStocksDocument = gql`
    query getStocks {
  stocks {
    id
    symbol
  }
}
    `;

/**
 * __useGetStocksQuery__
 *
 * To run a query within a React component, call `useGetStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStocksQuery(baseOptions?: Apollo.QueryHookOptions<GetStocksQuery, GetStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStocksQuery, GetStocksQueryVariables>(GetStocksDocument, options);
      }
export function useGetStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStocksQuery, GetStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStocksQuery, GetStocksQueryVariables>(GetStocksDocument, options);
        }
// @ts-ignore
export function useGetStocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStocksQuery, GetStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetStocksQuery, GetStocksQueryVariables>;
export function useGetStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStocksQuery, GetStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetStocksQuery | undefined, GetStocksQueryVariables>;
export function useGetStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStocksQuery, GetStocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStocksQuery, GetStocksQueryVariables>(GetStocksDocument, options);
        }
export type GetStocksQueryHookResult = ReturnType<typeof useGetStocksQuery>;
export type GetStocksLazyQueryHookResult = ReturnType<typeof useGetStocksLazyQuery>;
export type GetStocksSuspenseQueryHookResult = ReturnType<typeof useGetStocksSuspenseQuery>;
export type GetStocksQueryResult = Apollo.QueryResult<GetStocksQuery, GetStocksQueryVariables>;
export const SyncAccountTransactionsDocument = gql`
    mutation syncAccountTransactions($accountId: ID!, $limit: Int) {
  syncAccountTransactions(accountId: $accountId, limit: $limit) {
    id
    comment
  }
}
    `;
export type SyncAccountTransactionsMutationFn = Apollo.MutationFunction<SyncAccountTransactionsMutation, SyncAccountTransactionsMutationVariables>;

/**
 * __useSyncAccountTransactionsMutation__
 *
 * To run a mutation, you first call `useSyncAccountTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAccountTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAccountTransactionsMutation, { data, loading, error }] = useSyncAccountTransactionsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSyncAccountTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<SyncAccountTransactionsMutation, SyncAccountTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncAccountTransactionsMutation, SyncAccountTransactionsMutationVariables>(SyncAccountTransactionsDocument, options);
      }
export type SyncAccountTransactionsMutationHookResult = ReturnType<typeof useSyncAccountTransactionsMutation>;
export type SyncAccountTransactionsMutationResult = Apollo.MutationResult<SyncAccountTransactionsMutation>;
export type SyncAccountTransactionsMutationOptions = Apollo.BaseMutationOptions<SyncAccountTransactionsMutation, SyncAccountTransactionsMutationVariables>;
export const SyncLastTransactionsDocument = gql`
    mutation syncLastTransactions {
  syncLastTransactions {
    id
    comment
  }
}
    `;
export type SyncLastTransactionsMutationFn = Apollo.MutationFunction<SyncLastTransactionsMutation, SyncLastTransactionsMutationVariables>;

/**
 * __useSyncLastTransactionsMutation__
 *
 * To run a mutation, you first call `useSyncLastTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncLastTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncLastTransactionsMutation, { data, loading, error }] = useSyncLastTransactionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncLastTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<SyncLastTransactionsMutation, SyncLastTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncLastTransactionsMutation, SyncLastTransactionsMutationVariables>(SyncLastTransactionsDocument, options);
      }
export type SyncLastTransactionsMutationHookResult = ReturnType<typeof useSyncLastTransactionsMutation>;
export type SyncLastTransactionsMutationResult = Apollo.MutationResult<SyncLastTransactionsMutation>;
export type SyncLastTransactionsMutationOptions = Apollo.BaseMutationOptions<SyncLastTransactionsMutation, SyncLastTransactionsMutationVariables>;
export const SyncLastTransactionsForAllDocument = gql`
    mutation syncLastTransactionsForAll($limit: Int) {
  syncLastTransactionsForAll(limit: $limit) {
    id
    transactionsCount
    accountsCount
  }
}
    `;
export type SyncLastTransactionsForAllMutationFn = Apollo.MutationFunction<SyncLastTransactionsForAllMutation, SyncLastTransactionsForAllMutationVariables>;

/**
 * __useSyncLastTransactionsForAllMutation__
 *
 * To run a mutation, you first call `useSyncLastTransactionsForAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncLastTransactionsForAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncLastTransactionsForAllMutation, { data, loading, error }] = useSyncLastTransactionsForAllMutation({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSyncLastTransactionsForAllMutation(baseOptions?: Apollo.MutationHookOptions<SyncLastTransactionsForAllMutation, SyncLastTransactionsForAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncLastTransactionsForAllMutation, SyncLastTransactionsForAllMutationVariables>(SyncLastTransactionsForAllDocument, options);
      }
export type SyncLastTransactionsForAllMutationHookResult = ReturnType<typeof useSyncLastTransactionsForAllMutation>;
export type SyncLastTransactionsForAllMutationResult = Apollo.MutationResult<SyncLastTransactionsForAllMutation>;
export type SyncLastTransactionsForAllMutationOptions = Apollo.BaseMutationOptions<SyncLastTransactionsForAllMutation, SyncLastTransactionsForAllMutationVariables>;
export const TestSignalsDocument = gql`
    mutation testSignals {
  testSignals {
    id
  }
}
    `;
export type TestSignalsMutationFn = Apollo.MutationFunction<TestSignalsMutation, TestSignalsMutationVariables>;

/**
 * __useTestSignalsMutation__
 *
 * To run a mutation, you first call `useTestSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testSignalsMutation, { data, loading, error }] = useTestSignalsMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestSignalsMutation(baseOptions?: Apollo.MutationHookOptions<TestSignalsMutation, TestSignalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestSignalsMutation, TestSignalsMutationVariables>(TestSignalsDocument, options);
      }
export type TestSignalsMutationHookResult = ReturnType<typeof useTestSignalsMutation>;
export type TestSignalsMutationResult = Apollo.MutationResult<TestSignalsMutation>;
export type TestSignalsMutationOptions = Apollo.BaseMutationOptions<TestSignalsMutation, TestSignalsMutationVariables>;
export const TestSignalsForStockDocument = gql`
    mutation testSignalsForStock($stockId: String!) {
  testSignalsForStock(stockId: $stockId) {
    id
    signals {
      id
      rsi {
        id
        lastEvent {
          id
          buyValue
          sellValue
          type
          cause
          date
        }
      }
    }
  }
}
    `;
export type TestSignalsForStockMutationFn = Apollo.MutationFunction<TestSignalsForStockMutation, TestSignalsForStockMutationVariables>;

/**
 * __useTestSignalsForStockMutation__
 *
 * To run a mutation, you first call `useTestSignalsForStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestSignalsForStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testSignalsForStockMutation, { data, loading, error }] = useTestSignalsForStockMutation({
 *   variables: {
 *      stockId: // value for 'stockId'
 *   },
 * });
 */
export function useTestSignalsForStockMutation(baseOptions?: Apollo.MutationHookOptions<TestSignalsForStockMutation, TestSignalsForStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestSignalsForStockMutation, TestSignalsForStockMutationVariables>(TestSignalsForStockDocument, options);
      }
export type TestSignalsForStockMutationHookResult = ReturnType<typeof useTestSignalsForStockMutation>;
export type TestSignalsForStockMutationResult = Apollo.MutationResult<TestSignalsForStockMutation>;
export type TestSignalsForStockMutationOptions = Apollo.BaseMutationOptions<TestSignalsForStockMutation, TestSignalsForStockMutationVariables>;
export const TransactionCommentTypeAheadDocument = gql`
    query transactionCommentTypeAhead($comment: String!) {
  transactionCommentTypeAhead(comment: $comment) {
    items
  }
}
    `;

/**
 * __useTransactionCommentTypeAheadQuery__
 *
 * To run a query within a React component, call `useTransactionCommentTypeAheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionCommentTypeAheadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionCommentTypeAheadQuery({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useTransactionCommentTypeAheadQuery(baseOptions: Apollo.QueryHookOptions<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables> & ({ variables: TransactionCommentTypeAheadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>(TransactionCommentTypeAheadDocument, options);
      }
export function useTransactionCommentTypeAheadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>(TransactionCommentTypeAheadDocument, options);
        }
// @ts-ignore
export function useTransactionCommentTypeAheadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>;
export function useTransactionCommentTypeAheadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionCommentTypeAheadQuery | undefined, TransactionCommentTypeAheadQueryVariables>;
export function useTransactionCommentTypeAheadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>(TransactionCommentTypeAheadDocument, options);
        }
export type TransactionCommentTypeAheadQueryHookResult = ReturnType<typeof useTransactionCommentTypeAheadQuery>;
export type TransactionCommentTypeAheadLazyQueryHookResult = ReturnType<typeof useTransactionCommentTypeAheadLazyQuery>;
export type TransactionCommentTypeAheadSuspenseQueryHookResult = ReturnType<typeof useTransactionCommentTypeAheadSuspenseQuery>;
export type TransactionCommentTypeAheadQueryResult = Apollo.QueryResult<TransactionCommentTypeAheadQuery, TransactionCommentTypeAheadQueryVariables>;
export const TransactionValuesForSelectDocument = gql`
    query transactionValuesForSelect {
  groups {
    id
    name
    accounts {
      id
      name
      enabled
    }
    users {
      id
      firstname
      accounts {
        id
        name
        enabled
      }
    }
    contexts {
      id
      name
      posts {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTransactionValuesForSelectQuery__
 *
 * To run a query within a React component, call `useTransactionValuesForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionValuesForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionValuesForSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionValuesForSelectQuery(baseOptions?: Apollo.QueryHookOptions<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>(TransactionValuesForSelectDocument, options);
      }
export function useTransactionValuesForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>(TransactionValuesForSelectDocument, options);
        }
// @ts-ignore
export function useTransactionValuesForSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>;
export function useTransactionValuesForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionValuesForSelectQuery | undefined, TransactionValuesForSelectQueryVariables>;
export function useTransactionValuesForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>(TransactionValuesForSelectDocument, options);
        }
export type TransactionValuesForSelectQueryHookResult = ReturnType<typeof useTransactionValuesForSelectQuery>;
export type TransactionValuesForSelectLazyQueryHookResult = ReturnType<typeof useTransactionValuesForSelectLazyQuery>;
export type TransactionValuesForSelectSuspenseQueryHookResult = ReturnType<typeof useTransactionValuesForSelectSuspenseQuery>;
export type TransactionValuesForSelectQueryResult = Apollo.QueryResult<TransactionValuesForSelectQuery, TransactionValuesForSelectQueryVariables>;
export const TransactionsDocument = gql`
    query transactions($comment: String, $accountIds: [String!], $userIds: [String!], $groupIds: [String!], $contextIds: [String!], $postIds: [String!], $perPage: Int, $after: String, $before: String, $paymentType: PaymentTypeEnum, $autoMatchLabel: String, $amountMin: Int, $amountMax: Int) {
  listTransactions: listTransactions(
    filter: {comment: $comment, checked: true, accountIds: $accountIds, userIds: $userIds, groupIds: $groupIds, contextIds: $contextIds, postIds: $postIds, perPage: $perPage, after: $after, before: $before, paymentType: $paymentType, autoMatchLabel: $autoMatchLabel, amountMin: $amountMin, amountMax: $amountMax}
  ) {
    items {
      ...transactionFields
    }
  }
  uncheckedTransactions: listTransactions(
    filter: {checked: false, comment: $comment, accountIds: $accountIds, userIds: $userIds, groupIds: $groupIds, contextIds: $contextIds, postIds: $postIds, perPage: 500, after: $after, before: $before, paymentType: $paymentType, autoMatchLabel: $autoMatchLabel, amountMin: $amountMin, amountMax: $amountMax}
  ) {
    items {
      ...transactionFields
    }
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      comment: // value for 'comment'
 *      accountIds: // value for 'accountIds'
 *      userIds: // value for 'userIds'
 *      groupIds: // value for 'groupIds'
 *      contextIds: // value for 'contextIds'
 *      postIds: // value for 'postIds'
 *      perPage: // value for 'perPage'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      paymentType: // value for 'paymentType'
 *      autoMatchLabel: // value for 'autoMatchLabel'
 *      amountMin: // value for 'amountMin'
 *      amountMax: // value for 'amountMax'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
// @ts-ignore
export function useTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsQuery, TransactionsQueryVariables>;
export function useTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsQuery | undefined, TransactionsQueryVariables>;
export function useTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsSuspenseQueryHookResult = ReturnType<typeof useTransactionsSuspenseQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const UnfollowStockDocument = gql`
    mutation unfollowStock($stockId: ID!) {
  unfollowStock(stockId: $stockId) {
    id
    stocks {
      id
      follow
    }
  }
}
    `;
export type UnfollowStockMutationFn = Apollo.MutationFunction<UnfollowStockMutation, UnfollowStockMutationVariables>;

/**
 * __useUnfollowStockMutation__
 *
 * To run a mutation, you first call `useUnfollowStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowStockMutation, { data, loading, error }] = useUnfollowStockMutation({
 *   variables: {
 *      stockId: // value for 'stockId'
 *   },
 * });
 */
export function useUnfollowStockMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowStockMutation, UnfollowStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowStockMutation, UnfollowStockMutationVariables>(UnfollowStockDocument, options);
      }
export type UnfollowStockMutationHookResult = ReturnType<typeof useUnfollowStockMutation>;
export type UnfollowStockMutationResult = Apollo.MutationResult<UnfollowStockMutation>;
export type UnfollowStockMutationOptions = Apollo.BaseMutationOptions<UnfollowStockMutation, UnfollowStockMutationVariables>;
export const UnlinkBankAccountDocument = gql`
    mutation unlinkBankAccount($connectionId: String!) {
  unlinkBankAccount(connectionId: $connectionId) {
    id
  }
}
    `;
export type UnlinkBankAccountMutationFn = Apollo.MutationFunction<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>;

/**
 * __useUnlinkBankAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkBankAccountMutation, { data, loading, error }] = useUnlinkBankAccountMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useUnlinkBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>(UnlinkBankAccountDocument, options);
      }
export type UnlinkBankAccountMutationHookResult = ReturnType<typeof useUnlinkBankAccountMutation>;
export type UnlinkBankAccountMutationResult = Apollo.MutationResult<UnlinkBankAccountMutation>;
export type UnlinkBankAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkBankAccountMutation, UnlinkBankAccountMutationVariables>;
export const UpdateRsiSignalDocument = gql`
    mutation updateRsiSignal($stockId: ID!, $input: InputRsiStockSignal) {
  updateRsiSignal(stockId: $stockId, input: $input) {
    id
    stocks {
      id
      signals {
        id
        rsi {
          buySignal
          sellSignal
          maxBuys
          stopLoss
          id
          lastEvent {
            id
            buyValue
            sellValue
            type
            cause
            date
          }
        }
      }
    }
  }
}
    `;
export type UpdateRsiSignalMutationFn = Apollo.MutationFunction<UpdateRsiSignalMutation, UpdateRsiSignalMutationVariables>;

/**
 * __useUpdateRsiSignalMutation__
 *
 * To run a mutation, you first call `useUpdateRsiSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRsiSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRsiSignalMutation, { data, loading, error }] = useUpdateRsiSignalMutation({
 *   variables: {
 *      stockId: // value for 'stockId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRsiSignalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRsiSignalMutation, UpdateRsiSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRsiSignalMutation, UpdateRsiSignalMutationVariables>(UpdateRsiSignalDocument, options);
      }
export type UpdateRsiSignalMutationHookResult = ReturnType<typeof useUpdateRsiSignalMutation>;
export type UpdateRsiSignalMutationResult = Apollo.MutationResult<UpdateRsiSignalMutation>;
export type UpdateRsiSignalMutationOptions = Apollo.BaseMutationOptions<UpdateRsiSignalMutation, UpdateRsiSignalMutationVariables>;
export const UpdateSmaSignalDocument = gql`
    mutation updateSmaSignal($stockId: ID!, $input: InputSmaStockSignal) {
  updateSmaSignal(stockId: $stockId, input: $input) {
    id
    stocks {
      id
      signals {
        id
        sma {
          usedSma
          buyTrend
          daysInBuyTrend
          sellTrend
          daysInSellTrend
          maxBuys
          stopLoss
          id
        }
      }
    }
  }
}
    `;
export type UpdateSmaSignalMutationFn = Apollo.MutationFunction<UpdateSmaSignalMutation, UpdateSmaSignalMutationVariables>;

/**
 * __useUpdateSmaSignalMutation__
 *
 * To run a mutation, you first call `useUpdateSmaSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmaSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSmaSignalMutation, { data, loading, error }] = useUpdateSmaSignalMutation({
 *   variables: {
 *      stockId: // value for 'stockId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSmaSignalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSmaSignalMutation, UpdateSmaSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSmaSignalMutation, UpdateSmaSignalMutationVariables>(UpdateSmaSignalDocument, options);
      }
export type UpdateSmaSignalMutationHookResult = ReturnType<typeof useUpdateSmaSignalMutation>;
export type UpdateSmaSignalMutationResult = Apollo.MutationResult<UpdateSmaSignalMutation>;
export type UpdateSmaSignalMutationOptions = Apollo.BaseMutationOptions<UpdateSmaSignalMutation, UpdateSmaSignalMutationVariables>;
export const UpdateUserAccountDocument = gql`
    mutation updateUserAccount($userId: String!, $account: AccountInput!) {
  editUserAccount(userId: $userId, account: $account) {
    id
    accounts {
      id
      name
      type
      enabled
    }
  }
}
    `;
export type UpdateUserAccountMutationFn = Apollo.MutationFunction<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;

/**
 * __useUpdateUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountMutation, { data, loading, error }] = useUpdateUserAccountMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useUpdateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>(UpdateUserAccountDocument, options);
      }
export type UpdateUserAccountMutationHookResult = ReturnType<typeof useUpdateUserAccountMutation>;
export type UpdateUserAccountMutationResult = Apollo.MutationResult<UpdateUserAccountMutation>;
export type UpdateUserAccountMutationOptions = Apollo.BaseMutationOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;
export const TransactionsListValuesForSelectDocument = gql`
    query transactionsListValuesForSelect {
  users {
    id
    firstname
    accounts {
      id
      name
      enabled
    }
  }
  groups {
    id
    name
    accounts {
      id
      name
      enabled
    }
    users {
      id
      accounts {
        id
        name
        enabled
      }
    }
    contexts {
      id
      name
      posts {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTransactionsListValuesForSelectQuery__
 *
 * To run a query within a React component, call `useTransactionsListValuesForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsListValuesForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsListValuesForSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionsListValuesForSelectQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>(TransactionsListValuesForSelectDocument, options);
      }
export function useTransactionsListValuesForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>(TransactionsListValuesForSelectDocument, options);
        }
// @ts-ignore
export function useTransactionsListValuesForSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>;
export function useTransactionsListValuesForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsListValuesForSelectQuery | undefined, TransactionsListValuesForSelectQueryVariables>;
export function useTransactionsListValuesForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>(TransactionsListValuesForSelectDocument, options);
        }
export type TransactionsListValuesForSelectQueryHookResult = ReturnType<typeof useTransactionsListValuesForSelectQuery>;
export type TransactionsListValuesForSelectLazyQueryHookResult = ReturnType<typeof useTransactionsListValuesForSelectLazyQuery>;
export type TransactionsListValuesForSelectSuspenseQueryHookResult = ReturnType<typeof useTransactionsListValuesForSelectSuspenseQuery>;
export type TransactionsListValuesForSelectQueryResult = Apollo.QueryResult<TransactionsListValuesForSelectQuery, TransactionsListValuesForSelectQueryVariables>;